// src/mockData/mockTrail.ts
function readEnvVar(name) {
  try {
    const proc = Reflect.get(globalThis, "process");
    if (typeof proc !== "object" || proc === null) return void 0;
    const env = Reflect.get(proc, "env");
    if (typeof env !== "object" || env === null) return void 0;
    const value = Reflect.get(env, name);
    return typeof value === "string" ? value : void 0;
  } catch {
    return void 0;
  }
}
var MEDIA_BASE = readEnvVar("MOCK_TRAIL_MEDIA_BASE_URL") || "https://ixggixytcqrchzrhgfhv.supabase.co/storage/v1/object/public/media";
var mockTrail = {
  code: "TEST0001",
  type: "story",
  accessToken: null,
  trail: {
    id: "qwertyui-23456789-zxcvbn",
    version: 1,
    organisationName: "Hiltingbury PTA",
    attribution: "organisation",
    stories: [
      {
        code: "TEST0001",
        title: "Hocombe Mead Trail",
        accessToken: null,
        storyPoints: [
          {
            order: 0,
            code: "TEST0002",
            type: "location",
            title: "The Cool Hedgehog",
            pages: [
              {
                type: "pageLayout01",
                title: "The Cool Hedgehog",
                image: `${MEDIA_BASE}/images/woodland_creatures/Hedgehog.jpg`,
                content: "<p>As you near the end of your walk, you meet a young male hedgehog wearing an orange hoodie and a blue t-shirt. He introduces himself as Spike, the coolest hedgehog in the woodland. He teaches you some fun woodland games and shows you his collection of shiny treasures.</p>"
              }
            ],
            config: null
          },
          {
            order: 1,
            code: "TEST0003",
            type: "location",
            title: "The Ballerina Mouse",
            pages: [
              {
                type: "pageLayout01",
                title: "The Ballerina Mouse",
                image: `${MEDIA_BASE}/images/woodland_creatures/Mouse.jpg`,
                content: "<p>You come across a cute female mouse standing on a log, wearing a pink ballet tutu, a pink bow on her head, and holding a bunch of flowers. She introduces herself as Arabella, a graceful ballerina who loves to dance. She gives you an impromptu performance, pirouetting and leaping with ease and grace.</p>"
              }
            ],
            config: null
          },
          {
            order: 2,
            code: "TEST0004",
            type: "location",
            title: "The Brave Badger",
            pages: [
              {
                type: "pageLayout01",
                image: `${MEDIA_BASE}/images/woodland_creatures/Badger.jpg`,
                content: "<p>As you wander deeper into the forest, you meet a badger wearing a red cape and a gold necklace with a big red locket. He introduces himself as Sir Benedict the Brave, a noble knight who protects the woodland creatures from danger. He tells you stories of his daring adventures and his quests to keep the forest safe.</p>"
              }
            ],
            config: null
          },
          {
            order: 3,
            code: "TEST0005",
            type: "location",
            title: "The Flower Queen Rabbit",
            pages: [
              {
                type: "pageLayout01",
                title: "The Flower Queen Rabbit",
                image: `${MEDIA_BASE}/images/woodland_creatures/Rabbit.jpg`,
                content: "<p>While admiring a patch of colourful wildflowers, you meet a fluffy female rabbit wearing a long jacket and flowers in her hair. She introduces herself as Queen Rosalind, the ruler of the flower kingdom. She shows you her favourite blossoms and teaches you the secret language of flowers.<p>"
              }
            ],
            config: null
          }
        ],
        config: null
      }
    ],
    points: [
      {
        code: "TEST0002",
        lat: 50.999472,
        lng: -1.389806,
        type: "location",
        title: null,
        address: null,
        locationImage: null
      },
      {
        code: "TEST0003",
        lat: 51.002197,
        lng: -1.388735,
        type: "location",
        title: null,
        address: null,
        locationImage: null
      },
      {
        code: "TEST0004",
        lat: 51.00371,
        lng: -1.388056,
        type: "location",
        title: null,
        address: null,
        locationImage: null
      },
      {
        code: "TEST0005",
        lat: 51.003347,
        lng: -1.385086,
        type: "location",
        title: null,
        address: null,
        locationImage: null
      }
    ],
    config: null
  }
};

// src/selfieCatalog.ts
var SELFIE_LENSES = [
  {
    id: "starGlasses",
    name: "Star Glasses",
    emoji: "\u2B50",
    collection: "Classics"
  },
  {
    id: "wizardHat",
    name: "Wizard Hat",
    emoji: "\u{1F9D9}",
    collection: "Classics",
    motion: "A soft celestial crown with embroidered constellations"
  },
  {
    id: "crown",
    name: "Royal Crown",
    emoji: "\u{1F451}",
    collection: "Classics"
  },
  {
    id: "animalNose",
    name: "Animal Nose",
    emoji: "\u{1F98A}",
    collection: "Classics"
  },
  {
    id: "moonWitch",
    name: "Moon Witch",
    emoji: "\u{1F319}",
    collection: "Halloween",
    motion: "A crooked tip and swinging star"
  },
  {
    id: "batMask",
    name: "Bat Mask",
    emoji: "\u{1F987}",
    collection: "Halloween",
    motion: "Sculpted leather wings with flexible scalloped membranes"
  },
  {
    id: "pumpkinBeret",
    name: "Pumpkin Beret",
    emoji: "\u{1F383}",
    collection: "Halloween",
    motion: "A bouncy stalk and leaf"
  },
  {
    id: "santaHat",
    name: "Santa Hat",
    emoji: "\u{1F385}",
    collection: "Christmas",
    motion: "Soft velvet folds and a pompom that bend with your head"
  },
  {
    id: "jingleElf",
    name: "Jingle Elf",
    emoji: "\u{1F9DD}",
    collection: "Christmas",
    motion: "A curling tip with a golden bell"
  },
  {
    id: "reindeer",
    name: "Reindeer",
    emoji: "\u{1F98C}",
    collection: "Christmas",
    motion: "Springy antlers, ears and dangling bells"
  },
  {
    id: "bunnyEars",
    name: "Bunny Ears",
    emoji: "\u{1F430}",
    collection: "Playtime",
    motion: "Plush ears that bend, compress and settle independently"
  },
  {
    id: "spaceAntennae",
    name: "Space Antennae",
    emoji: "\u{1FA90}",
    collection: "Playtime",
    motion: "Tiny planets on spring antennae"
  },
  {
    id: "foxMask",
    name: "Fox Mask",
    emoji: "\u{1F98A}",
    collection: "Playtime",
    motion: "A woodland mask with twitchy ears"
  },
  {
    id: "mushroomCap",
    name: "Toadstool Cap",
    emoji: "\u{1F344}",
    collection: "Halloween",
    motion: "A soft velvet canopy with ivory spots and delicate gills"
  },
  {
    id: "jesterHat",
    name: "Velvet Jester",
    emoji: "\u{1F0CF}",
    collection: "Playtime",
    motion: "Two floppy velvet points that bend and settle independently"
  },
  {
    id: "frostCrown",
    name: "Frost Crown",
    emoji: "\u2744\uFE0F",
    collection: "Christmas",
    motion: "Faceted ice crystals and swinging silver snowflakes"
  },
  {
    id: "voodooTopHat",
    name: "Skull Top Hat",
    emoji: "\u{1F480}",
    collection: "Halloween",
    motion: "A plum top hat with an ivory skull, soft feather and dangling charm"
  },
  {
    id: "devilHorns",
    name: "Devil Horns",
    emoji: "\u{1F608}",
    collection: "Halloween",
    motion: "Curved ruby horns with a little elastic sway"
  },
  {
    id: "pumpkinGlasses",
    name: "Pumpkin Glasses",
    emoji: "\u{1F383}",
    collection: "Halloween",
    motion: "Two cute carved pumpkins with bouncy stalks, solid over the eyes"
  },
  {
    id: "pirateTricorn",
    name: "Pirate Tricorn",
    emoji: "\u{1F3F4}\u200D\u2620\uFE0F",
    collection: "Pirates",
    motion: "A stitched leather tricorn with a skull and a fluttering scarlet feather"
  },
  {
    id: "pirateCaptain",
    name: "Pirate Captain",
    emoji: "\u2693",
    collection: "Pirates",
    motion: "A navy bicorne, ivory skull, soft plume and swinging gold tassel"
  },
  {
    id: "pirateBandana",
    name: "Pirate Bandana",
    emoji: "\u{1F3F4}\u200D\u2620\uFE0F",
    collection: "Pirates",
    motion: "A scarlet scarf with soft tails, an eyepatch and a dangling gold hoop"
  },
  {
    id: "santaBeard",
    name: "Santa & Beard",
    emoji: "\u{1F385}",
    collection: "Christmas",
    motion: "A floppy Santa cap, curled moustache and softly swaying beard"
  }
];
var ALL_SELFIE_LENSES = SELFIE_LENSES.map(
  ({ id }) => id
);
var DEFAULT_SELFIE_LENSES = SELFIE_LENSES.filter(
  ({ collection }) => collection === "Classics"
).map(({ id }) => id);

// src/zodSchemas/points.ts
import { z } from "zod";
var code = z.string().min(8);
var codeParamSchema = z.string().trim().regex(/^[A-Za-z0-9]{8,32}$/);
var basePointSchema = z.object({
  id: z.string(),
  code,
  trail: z.string(),
  created_at: z.string()
});
var locationPointSchema = basePointSchema.extend({
  type: z.literal("location"),
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  title: z.nullable(z.string()),
  address: z.nullable(z.string()),
  locationImage: z.nullable(z.string())
});
var urlRedirectPointSchema = basePointSchema.extend({
  type: z.literal("urlRedirect"),
  redirectUrl: z.nullable(z.string())
});
var storyAccessPointSchema = basePointSchema.extend({
  type: z.literal("story"),
  story: z.string().nullable(),
  accessToken: z.nullable(z.string())
});
var arMarkerPointSchema = basePointSchema.extend({
  type: z.literal("arMarker"),
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  title: z.nullable(z.string()),
  address: z.nullable(z.string()),
  locationImage: z.nullable(z.string()),
  markerSizeMm: z.optional(z.number())
});
var trailPointSchema = z.union([
  locationPointSchema,
  urlRedirectPointSchema,
  storyAccessPointSchema,
  arMarkerPointSchema
]);

// src/zodSchemas/pages.ts
import { z as z2 } from "zod";

// src/nfc.ts
var NFC_TAP_QUERY_PARAM = "nfc";
var NFC_TAP_TOKEN_LENGTH = 10;
var NFC_TAP_TOKEN_MIN_LENGTH = 6;
var NFC_TAP_TOKEN_MAX_LENGTH = 32;
var NFC_TAP_TOKEN_PATTERN = /^[a-z0-9]{6,32}$/;
var NFC_TAP_TOKEN_ALPHABET = "abcdefghjkmnpqrstuvwxyz23456789";
var NFC_TAP_FALLBACK_CODE_MAX_LENGTH = 32;
var UNBIASED_BYTE_LIMIT = 256 - 256 % NFC_TAP_TOKEN_ALPHABET.length;
var RELATIVE_URL_BASE = "https://nfc.invalid";
function randomBytes(count) {
  const bytes = new Uint8Array(count);
  const webCrypto = globalThis.crypto;
  if (typeof webCrypto?.getRandomValues === "function") {
    webCrypto.getRandomValues(bytes);
    return bytes;
  }
  for (let index = 0; index < count; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256);
  }
  return bytes;
}
function generateNfcToken(length = NFC_TAP_TOKEN_LENGTH) {
  const size = Math.min(
    Math.max(Math.round(length), NFC_TAP_TOKEN_MIN_LENGTH),
    NFC_TAP_TOKEN_MAX_LENGTH
  );
  let token = "";
  while (token.length < size) {
    const bytes = randomBytes(size - token.length + 8);
    for (let index = 0; index < bytes.length && token.length < size; index += 1) {
      const byte = bytes[index];
      if (byte >= UNBIASED_BYTE_LIMIT) continue;
      token += NFC_TAP_TOKEN_ALPHABET[byte % NFC_TAP_TOKEN_ALPHABET.length];
    }
  }
  return token;
}
function normalizeNfcToken(raw) {
  return raw.trim().toLowerCase();
}
function isValidNfcToken(raw) {
  return NFC_TAP_TOKEN_PATTERN.test(normalizeNfcToken(raw));
}
function nfcTapTagUrl(joinUrl, token) {
  const trimmed = joinUrl.trim();
  const withScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(withScheme);
    url.searchParams.set(NFC_TAP_QUERY_PARAM, normalizeNfcToken(token));
    return url.toString();
  } catch {
    return trimmed;
  }
}
function nfcTokenFromUrl(url) {
  const trimmed = url.trim();
  if (!trimmed) return void 0;
  let parsed;
  try {
    parsed = new URL(trimmed, RELATIVE_URL_BASE);
  } catch {
    return void 0;
  }
  const raw = parsed.searchParams.get(NFC_TAP_QUERY_PARAM);
  if (!raw) return void 0;
  const token = normalizeNfcToken(raw);
  return isValidNfcToken(token) ? token : void 0;
}
function nfcTokenFromText(text) {
  const trimmed = text.trim();
  if (!trimmed) return void 0;
  const bare = normalizeNfcToken(trimmed);
  if (isValidNfcToken(bare)) return bare;
  return nfcTokenFromUrl(trimmed);
}
function normalizeNfcFallbackCode(raw) {
  return raw.trim().replace(/\s+/g, " ").toLowerCase();
}
function withFreshNfcTokens(pages) {
  return pages.map(
    (page2) => page2.type === "nfcTap" ? { ...page2, token: generateNfcToken() } : page2
  );
}

// src/zodSchemas/pages.ts
var pageParticles = z2.optional(z2.enum(["snow"]));
var pageLayout01 = z2.object({
  type: z2.literal("pageLayout01"),
  title: z2.optional(z2.string()),
  image: z2.string(),
  altText: z2.optional(z2.string()),
  allowNavigation: z2.optional(z2.boolean()),
  content: z2.string(),
  particles: pageParticles,
  showCloseButton: z2.optional(z2.boolean()),
  closeButtonText: z2.optional(z2.string())
});
var pageLayout02 = z2.object({
  type: z2.literal("pageLayout02"),
  title: z2.optional(z2.string()),
  image: z2.optional(z2.string()),
  altText: z2.optional(z2.string()),
  content: z2.string(),
  allowNavigation: z2.optional(z2.boolean()),
  showCloseButton: z2.optional(z2.boolean()),
  closeButtonText: z2.optional(z2.string())
});
var pageReveal01 = z2.object({
  type: z2.literal("pageReveal01"),
  title: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  objectImage: z2.optional(z2.string()),
  objectSplitTopImage: z2.optional(z2.string()),
  objectSplitBottomImage: z2.optional(z2.string()),
  revealedImage: z2.optional(z2.string())
});
var questionPage = z2.object({
  type: z2.literal("question"),
  title: z2.optional(z2.string()),
  question: z2.string(),
  answerType: z2.enum(["text", "number", "multipleChoice"]),
  choices: z2.optional(z2.array(z2.string())),
  answer: z2.string(),
  backgroundImage: z2.optional(z2.string()),
  questionImage: z2.optional(z2.string()),
  correctAnswerImage: z2.optional(z2.string()),
  wrongAnswerImage: z2.optional(z2.string()),
  userAnswer: z2.optional(z2.string()),
  // Only used client side
  immediateAnswer: z2.optional(z2.boolean()),
  answerTolerance: z2.optional(z2.number()),
  /**
   * What the asker says back, in words. The phone shell's messenger posts
   * these as the sender's reply; same names as the game pages use.
   */
  completeText: z2.optional(z2.string()),
  wrongAnswerText: z2.optional(z2.string())
});
var iframePage = z2.object({
  type: z2.literal("iframe"),
  title: z2.optional(z2.string()),
  // Kept as a string type, but reject non-https URLs at parse time: the player
  // embeds this URL in an iframe, so javascript:/data:/http: must never reach it.
  iframeUrl: z2.string().refine(
    (value) => {
      try {
        return new URL(value).protocol === "https:";
      } catch {
        return false;
      }
    },
    { message: "iframeUrl must be an https:// URL" }
  ),
  allowNavigation: z2.optional(z2.boolean())
});
var starburstPage = z2.object({
  type: z2.literal("starburst"),
  title: z2.optional(z2.string()),
  image: z2.string(),
  starburstImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  altText: z2.optional(z2.string()),
  allowNavigation: z2.optional(z2.boolean()),
  content: z2.optional(z2.string())
});
var baseGame = z2.object({
  title: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  completeText: z2.optional(z2.string()),
  wrongAnswerImage: z2.optional(z2.string()),
  wrongAnswerTitle: z2.optional(z2.string()),
  wrongAnswerText: z2.optional(z2.string())
});
var tapTheThingGame = baseGame.extend({
  type: z2.literal("tapTheThingGame"),
  images: z2.array(z2.string()).min(1),
  targetScore: z2.number(),
  movementStyle: z2.enum(["falling", "rising", "floating"]),
  particleColor: z2.optional(
    z2.enum(["confetti", "fire", "magic", "white", "custom"])
  ),
  customParticleColors: z2.optional(z2.array(z2.string())),
  speed: z2.optional(z2.number()),
  size: z2.optional(z2.number()),
  particleCount: z2.optional(z2.number()),
  thingCount: z2.optional(z2.number()),
  rotationSpeed: z2.optional(z2.number())
});
var imageSliceMatcherGame = baseGame.extend({
  type: z2.literal("imageSliceMatcherGame"),
  images: z2.array(z2.string()).min(2),
  correctIndex: z2.number(),
  sections: z2.array(z2.number()).min(1),
  aspectRatio: z2.optional(z2.string())
});
var slidingTilePuzzleGame = baseGame.extend({
  type: z2.literal("slidingTilePuzzleGame"),
  image: z2.string(),
  difficulty: z2.enum(["easy", "medium", "hard"]),
  gridSize: z2.optional(z2.number())
});
var decoderRingGame = baseGame.extend({
  type: z2.literal("decoderRingGame"),
  message: z2.string(),
  emojiSet: z2.enum(["default", "easter", "halloween", "christmas"]),
  customEmojiSet: z2.optional(z2.array(z2.string()))
});
var gadgetTheme = z2.enum([
  "classic",
  "scifi",
  "steampunk",
  "spy",
  "enchanted",
  "pumpkin"
]);
var scannerTheme = gadgetTheme;
var hiddenRevealStyle = z2.enum([
  "auto",
  "magical",
  "hologram",
  "forensic",
  "spy"
]);
var visionMatchPage = baseGame.extend({
  type: z2.literal("visionMatch"),
  visionMatchImages: z2.array(z2.string()).min(1),
  matchThreshold: z2.optional(z2.number()),
  // Defaults to 15 if not set
  /** Scanner overlay look. Defaults to 'classic'. */
  scannerTheme: z2.optional(scannerTheme),
  /** Short plain-text hint shown over the live view, e.g. "Scan the sign post". */
  scannerHint: z2.optional(z2.string()),
  /** Show the target image on a second screen under the live view. Defaults to true. */
  showTargetPreview: z2.optional(z2.boolean()),
  /**
   * The hidden message: once the sign is matched it is projected ONTO the
   * sign in the live view (warped to the sign's outline) and the page waits
   * for the player to read it. Either a short plain-text line, an image, or
   * both (the text sits under the image). Empty = the classic instant match.
   */
  hiddenText: z2.optional(z2.string()),
  hiddenImage: z2.optional(z2.string()),
  /** The reveal effect. Player-side default 'auto'. */
  revealStyle: z2.optional(hiddenRevealStyle),
  skipQuestion: z2.optional(z2.string()),
  skipQuestionAnswer: z2.optional(z2.string())
});
var objectScanTarget = z2.enum([
  "person",
  "bicycle",
  "car",
  "motorcycle",
  "airplane",
  "bus",
  "train",
  "truck",
  "boat",
  "traffic light",
  "fire hydrant",
  "stop sign",
  "parking meter",
  "bench",
  "bird",
  "cat",
  "dog",
  "horse",
  "sheep",
  "cow",
  "elephant",
  "bear",
  "zebra",
  "giraffe",
  "backpack",
  "umbrella",
  "handbag",
  "tie",
  "suitcase",
  "frisbee",
  "skis",
  "snowboard",
  "sports ball",
  "kite",
  "baseball bat",
  "baseball glove",
  "skateboard",
  "surfboard",
  "tennis racket",
  "bottle",
  "wine glass",
  "cup",
  "fork",
  "knife",
  "spoon",
  "bowl",
  "banana",
  "apple",
  "sandwich",
  "orange",
  "broccoli",
  "carrot",
  "hot dog",
  "pizza",
  "donut",
  "cake",
  "chair",
  "couch",
  "potted plant",
  "bed",
  "dining table",
  "toilet",
  "tv",
  "laptop",
  "mouse",
  "remote",
  "keyboard",
  "cell phone",
  "microwave",
  "oven",
  "toaster",
  "sink",
  "refrigerator",
  "book",
  "clock",
  "vase",
  "scissors",
  "teddy bear",
  "hair drier",
  "toothbrush"
]);
var OBJECT_SCAN_TARGET_IDS = objectScanTarget.options;
var target = (id, label, emoji, where, article = "a") => ({ id, label, emoji, article, where });
var OBJECT_SCAN_TARGET_INFO = {
  person: target(
    "person",
    "Person",
    "\u{1F9CD}",
    "The most reliable class of all: fires on anyone in shot, so it is only useful as a warm-up."
  ),
  dog: target(
    "dog",
    "Dog",
    "\u{1F415}",
    "Reliable outdoors: most dogs on a lead fire from a few metres away."
  ),
  cat: target("cat", "Cat", "\u{1F408}", "Reliable when the cat sits still for it."),
  bird: target(
    "bird",
    "Bird",
    "\u{1F426}",
    "Pigeons, ducks and gulls fire well when they fill a good part of the frame."
  ),
  horse: target(
    "horse",
    "Horse",
    "\u{1F40E}",
    "Reliable in a field or on a bridleway."
  ),
  sheep: target(
    "sheep",
    "Sheep",
    "\u{1F411}",
    "Reliable in a field, even at a distance."
  ),
  cow: target("cow", "Cow", "\u{1F404}", "Reliable in a field, even at a distance."),
  bear: target(
    "bear",
    "Bear",
    "\u{1F43B}",
    "Zoo or statue only. A large teddy can fire as a bear too."
  ),
  elephant: target("elephant", "Elephant", "\u{1F418}", "Zoo or statue only.", "an"),
  zebra: target("zebra", "Zebra", "\u{1F993}", "Zoo only."),
  giraffe: target("giraffe", "Giraffe", "\u{1F992}", "Zoo only."),
  bicycle: target(
    "bicycle",
    "Bicycle",
    "\u{1F6B2}",
    "Reliable: parked bikes and cycle racks fire well from the side."
  ),
  car: target("car", "Car", "\u{1F697}", "Very reliable in any street or car park."),
  motorcycle: target(
    "motorcycle",
    "Motorbike",
    "\u{1F3CD}\uFE0F",
    "Reliable when seen from the side; scooters usually count too."
  ),
  bus: target(
    "bus",
    "Bus",
    "\u{1F68C}",
    "Reliable at a bus stop; a passing bus may need the hold time turning down."
  ),
  train: target(
    "train",
    "Train",
    "\u{1F686}",
    "Reliable at a platform or level crossing; trams and heritage engines count."
  ),
  truck: target(
    "truck",
    "Lorry or van",
    "\u{1F69A}",
    "Fires on lorries, vans and pickups alike, so name it carefully in the copy."
  ),
  boat: target(
    "boat",
    "Boat",
    "\u26F5",
    "Reliable on a canal, harbour or boating lake."
  ),
  airplane: target(
    "airplane",
    "Aeroplane",
    "\u2708\uFE0F",
    "Only near an airfield or museum; a plane high overhead is too small.",
    "an"
  ),
  bench: target(
    "bench",
    "Bench",
    "\u{1FA91}",
    "Reliable: park and street benches fire well from a few metres away."
  ),
  "traffic light": target(
    "traffic light",
    "Traffic light",
    "\u{1F6A6}",
    "Reliable from the pavement; needs a reasonably close view."
  ),
  "stop sign": target(
    "stop sign",
    "Stop sign",
    "\u{1F6D1}",
    "Trained on the red octagon, which is rare in the UK. Other road signs do not fire."
  ),
  "fire hydrant": target(
    "fire hydrant",
    "Fire hydrant",
    "\u{1F9EF}",
    "Trained on the American pillar style; UK hydrant plates do not fire."
  ),
  "parking meter": target(
    "parking meter",
    "Parking meter",
    "\u{1F17F}\uFE0F",
    "Patchy: pay-and-display machines sometimes fire, sometimes not."
  ),
  backpack: target(
    "backpack",
    "Rucksack",
    "\u{1F392}",
    "Reliable on someone in the group; a good hands-free choice for a family."
  ),
  handbag: target(
    "handbag",
    "Handbag",
    "\u{1F45C}",
    "Reasonably reliable on a person or held up to the camera."
  ),
  umbrella: target(
    "umbrella",
    "Umbrella",
    "\u2602\uFE0F",
    "Reliable when open; a folded one rarely fires.",
    "an"
  ),
  suitcase: target(
    "suitcase",
    "Suitcase",
    "\u{1F9F3}",
    "Reliable at a station; wheeled cabin bags count."
  ),
  tie: target("tie", "Tie", "\u{1F454}", "Reliable on a person, close up."),
  "sports ball": target(
    "sports ball",
    "Ball",
    "\u26BD",
    "Reliable with a football or tennis ball held up to the camera."
  ),
  frisbee: target(
    "frisbee",
    "Frisbee",
    "\u{1F94F}",
    "Reliable held up to the camera or in flight close by."
  ),
  kite: target(
    "kite",
    "Kite",
    "\u{1FA81}",
    "Reliable when it fills a good part of the frame."
  ),
  skateboard: target(
    "skateboard",
    "Skateboard",
    "\u{1F6F9}",
    "Reliable at a skate park, with or without a rider."
  ),
  "tennis racket": target(
    "tennis racket",
    "Tennis racket",
    "\u{1F3BE}",
    "Reliable held up to the camera; a badminton racket often counts."
  ),
  "baseball bat": target(
    "baseball bat",
    "Baseball bat",
    "\u{1F3CF}",
    "Patchy: a rounders or cricket bat may or may not fire."
  ),
  "baseball glove": target(
    "baseball glove",
    "Baseball glove",
    "\u{1F94E}",
    "Rare in the UK; ordinary gloves do not fire."
  ),
  skis: target("skis", "Skis", "\u{1F3BF}", "Only at a snow centre or slope."),
  snowboard: target(
    "snowboard",
    "Snowboard",
    "\u{1F3C2}",
    "Only at a snow centre or slope."
  ),
  surfboard: target(
    "surfboard",
    "Surfboard",
    "\u{1F3C4}",
    "Reliable at the beach; paddleboards often count."
  ),
  bottle: target(
    "bottle",
    "Bottle",
    "\u{1F37E}",
    "Reliable: a water bottle held up to the camera is an easy indoor target."
  ),
  cup: target(
    "cup",
    "Cup or mug",
    "\u2615",
    "Reliable on a table or held up to the camera; takeaway cups count."
  ),
  "wine glass": target(
    "wine glass",
    "Wine glass",
    "\u{1F377}",
    "Reliable on a table; a pub garden makes it easy."
  ),
  bowl: target("bowl", "Bowl", "\u{1F963}", "Reliable on a table, seen from above."),
  fork: target(
    "fork",
    "Fork",
    "\u{1F374}",
    "Reasonably reliable on a table, close up."
  ),
  knife: target(
    "knife",
    "Knife",
    "\u{1F52A}",
    "Reasonably reliable on a table, close up."
  ),
  spoon: target(
    "spoon",
    "Spoon",
    "\u{1F944}",
    "Reasonably reliable on a table, close up."
  ),
  book: target(
    "book",
    "Book",
    "\u{1F4D6}",
    "Reliable held up to the camera or on a shelf; a library makes it easy."
  ),
  clock: target(
    "clock",
    "Clock",
    "\u{1F570}\uFE0F",
    "Reliable: church, station and town-hall clock faces fire from a distance."
  ),
  vase: target(
    "vase",
    "Vase",
    "\u{1F3FA}",
    "Reasonably reliable indoors or in a garden centre."
  ),
  scissors: target(
    "scissors",
    "Scissors",
    "\u2702\uFE0F",
    "Reliable held up to the camera, open or closed."
  ),
  "teddy bear": target(
    "teddy bear",
    "Teddy bear",
    "\u{1F9F8}",
    "Reliable: the friendliest target for a young family, bring one along."
  ),
  toothbrush: target(
    "toothbrush",
    "Toothbrush",
    "\u{1FAA5}",
    "Reliable held up to the camera, close."
  ),
  "hair drier": target(
    "hair drier",
    "Hairdryer",
    "\u{1F4A8}",
    "Reliable indoors, close up."
  ),
  "cell phone": target(
    "cell phone",
    "Mobile phone",
    "\u{1F4F1}",
    "Reliable: another phone held up to the camera fires almost every time."
  ),
  laptop: target("laptop", "Laptop", "\u{1F4BB}", "Reliable indoors, open or closed."),
  keyboard: target(
    "keyboard",
    "Keyboard",
    "\u2328\uFE0F",
    "Reliable on a desk; a piano keyboard does not count."
  ),
  mouse: target(
    "mouse",
    "Computer mouse",
    "\u{1F5B1}\uFE0F",
    "The computer kind, not the animal. Reliable on a desk, close up."
  ),
  remote: target(
    "remote",
    "Remote control",
    "\u{1F4FA}",
    "Reliable held up to the camera."
  ),
  banana: target(
    "banana",
    "Banana",
    "\u{1F34C}",
    "Reliable held up to the camera or in a bowl."
  ),
  apple: target(
    "apple",
    "Apple",
    "\u{1F34E}",
    "Reliable held up to the camera; a market stall makes it easy.",
    "an"
  ),
  orange: target(
    "orange",
    "Orange",
    "\u{1F34A}",
    "Reliable held up to the camera; satsumas count.",
    "an"
  ),
  sandwich: target(
    "sandwich",
    "Sandwich",
    "\u{1F96A}",
    "Reasonably reliable on a plate; burgers sometimes fire as a sandwich."
  ),
  pizza: target("pizza", "Pizza", "\u{1F355}", "Reliable on a plate or in the box."),
  "hot dog": target(
    "hot dog",
    "Hot dog",
    "\u{1F32D}",
    "Reliable in a bun; a plain sausage rarely fires."
  ),
  donut: target(
    "donut",
    "Doughnut",
    "\u{1F369}",
    "Reliable: a ring doughnut held up to the camera fires well."
  ),
  cake: target("cake", "Cake", "\u{1F382}", "Reliable on a plate; cupcakes count."),
  broccoli: target(
    "broccoli",
    "Broccoli",
    "\u{1F966}",
    "Reliable held up to the camera or on a market stall."
  ),
  carrot: target(
    "carrot",
    "Carrot",
    "\u{1F955}",
    "Reliable held up to the camera or on a market stall."
  ),
  chair: target(
    "chair",
    "Chair",
    "\u{1FA91}",
    "Very reliable indoors and in cafe gardens."
  ),
  couch: target(
    "couch",
    "Sofa",
    "\u{1F6CB}\uFE0F",
    "Reliable indoors from across the room."
  ),
  "dining table": target(
    "dining table",
    "Table",
    "\u{1F37D}\uFE0F",
    "Reliable indoors and at picnic tables when things are on it."
  ),
  bed: target("bed", "Bed", "\u{1F6CF}\uFE0F", "Reliable indoors from across the room."),
  "potted plant": target(
    "potted plant",
    "Potted plant",
    "\u{1FAB4}",
    "Reliable indoors, on a doorstep or in a garden centre."
  ),
  tv: target(
    "tv",
    "TV",
    "\u{1F4FA}",
    "Reliable indoors, on or off; a large monitor counts."
  ),
  microwave: target(
    "microwave",
    "Microwave",
    "\u{1F532}",
    "Reliable in a kitchen, close up."
  ),
  oven: target("oven", "Oven", "\u{1F373}", "Reliable in a kitchen, close up.", "an"),
  toaster: target(
    "toaster",
    "Toaster",
    "\u{1F35E}",
    "Reliable in a kitchen, close up."
  ),
  sink: target(
    "sink",
    "Sink",
    "\u{1F6B0}",
    "Reliable in a kitchen or bathroom, seen from above."
  ),
  refrigerator: target(
    "refrigerator",
    "Fridge",
    "\u{1F9CA}",
    "Reliable in a kitchen from across the room."
  ),
  toilet: target("toilet", "Toilet", "\u{1F6BD}", "Reliable, close up.")
};
var group = (label, ids) => ({
  label,
  targets: ids.map((id) => OBJECT_SCAN_TARGET_INFO[id])
});
var OBJECT_SCAN_TARGET_GROUPS = [
  group("People and animals", [
    "person",
    "dog",
    "cat",
    "bird",
    "horse",
    "sheep",
    "cow",
    "bear",
    "elephant",
    "zebra",
    "giraffe"
  ]),
  group("Vehicles and street", [
    "bench",
    "bicycle",
    "car",
    "motorcycle",
    "bus",
    "train",
    "truck",
    "boat",
    "airplane",
    "traffic light",
    "stop sign",
    "fire hydrant",
    "parking meter"
  ]),
  group("Everyday things", [
    "backpack",
    "handbag",
    "umbrella",
    "suitcase",
    "tie",
    "sports ball",
    "frisbee",
    "kite",
    "skateboard",
    "tennis racket",
    "baseball bat",
    "baseball glove",
    "skis",
    "snowboard",
    "surfboard",
    "bottle",
    "cup",
    "wine glass",
    "bowl",
    "fork",
    "knife",
    "spoon",
    "book",
    "clock",
    "vase",
    "scissors",
    "teddy bear",
    "toothbrush",
    "hair drier",
    "cell phone",
    "laptop",
    "keyboard",
    "mouse",
    "remote"
  ]),
  group("Food", [
    "banana",
    "apple",
    "orange",
    "sandwich",
    "pizza",
    "hot dog",
    "donut",
    "cake",
    "broccoli",
    "carrot"
  ]),
  group("Indoors", [
    "chair",
    "couch",
    "dining table",
    "bed",
    "potted plant",
    "tv",
    "microwave",
    "oven",
    "toaster",
    "sink",
    "refrigerator",
    "toilet"
  ])
];
var OBJECT_SCAN_TARGET_CATALOG = OBJECT_SCAN_TARGET_GROUPS.flatMap((g) => g.targets);
var KNOWN_OBJECT_SCAN_TARGETS = new Set(OBJECT_SCAN_TARGET_IDS);
var isObjectScanTarget = (value) => typeof value === "string" && KNOWN_OBJECT_SCAN_TARGETS.has(value);
var objectScanTargetInfo = (id) => isObjectScanTarget(id) ? OBJECT_SCAN_TARGET_INFO[id] : void 0;
var OBJECT_SCAN_MIN_CONFIDENCE = 0.2;
var OBJECT_SCAN_MAX_CONFIDENCE = 0.9;
var OBJECT_SCAN_DEFAULT_CONFIDENCE = 0.5;
var OBJECT_SCAN_MAX_HOLD_SECONDS = 5;
var OBJECT_SCAN_DEFAULT_HOLD_SECONDS = 1;
var objectScanPage = baseGame.extend({
  type: z2.literal("objectScan"),
  /** The thing to find; one of the detector's 80 classes. */
  targetObject: objectScanTarget,
  /**
   * Minimum detector score (0.2 to 0.9) for a sighting to count. Player-side
   * default 0.5. Lower fires more readily but on more look-alikes.
   */
  confidence: z2.optional(
    z2.number().min(OBJECT_SCAN_MIN_CONFIDENCE).max(OBJECT_SCAN_MAX_CONFIDENCE)
  ),
  /**
   * How long the thing must stay in view (0 to 5 seconds) before the page
   * completes. Player-side default 1 second, with a short grace so one dropped
   * frame does not start the count over.
   */
  holdSeconds: z2.optional(z2.number().min(0).max(OBJECT_SCAN_MAX_HOLD_SECONDS)),
  /** Scanner overlay look. Defaults to 'classic'. */
  scannerTheme: z2.optional(scannerTheme),
  /** Short plain-text hint shown over the live view, e.g. "Find a bench". */
  scannerHint: z2.optional(z2.string()),
  /** Show the "Find this" chip (emoji + label) over the live view. Default true. */
  showTargetPreview: z2.optional(z2.boolean()),
  skipQuestion: z2.optional(z2.string()),
  skipQuestionAnswer: z2.optional(z2.string())
});
var spriteSpec = z2.object({
  imageUrl: z2.string(),
  frames: z2.number(),
  fps: z2.number(),
  frameSize: z2.tuple([z2.number(), z2.number()])
});
var snapChaseGame = baseGame.extend({
  type: z2.literal("snapChase"),
  panoImageUrl: z2.string(),
  character: spriteSpec,
  distance: z2.number().optional(),
  size: z2.number().optional(),
  characterMovementX: z2.number().optional(),
  characterMovementY: z2.number().optional(),
  characterSpeed: z2.number().optional(),
  spawnInFront: z2.boolean().optional(),
  characterRotation: z2.number().optional(),
  fallbackMode: z2.boolean().optional(),
  /**
   * World-anchored movement style: 'fly' hovers the character above its
   * ground anchor (default — matches every existing flying/floating
   * character); 'ground' puts it ON the floor, running around its anchor.
   * Only the world-AR path reads this; fallback modes ignore it.
   */
  locomotion: z2.enum(["fly", "ground"]).optional()
});
var audioPage = z2.object({
  type: z2.literal("audioPage"),
  title: z2.optional(z2.string()),
  image: z2.optional(z2.string()),
  altText: z2.optional(z2.string()),
  content: z2.string(),
  audioUrl: z2.string(),
  transcript: z2.optional(z2.string()),
  autoplay: z2.optional(z2.boolean()),
  autoAdvance: z2.optional(z2.boolean()),
  allowNavigation: z2.optional(z2.boolean()),
  showCloseButton: z2.optional(z2.boolean()),
  closeButtonText: z2.optional(z2.string())
});
var videoPage = z2.object({
  type: z2.literal("videoPage"),
  title: z2.optional(z2.string()),
  videoUrl: z2.string(),
  posterImage: z2.optional(z2.string()),
  caption: z2.optional(z2.string()),
  autoAdvance: z2.optional(z2.boolean()),
  loop: z2.optional(z2.boolean()),
  startMuted: z2.optional(z2.boolean()),
  allowNavigation: z2.optional(z2.boolean())
});
var selfieLens = z2.enum([
  "wizardHat",
  "crown",
  "starGlasses",
  "animalNose",
  "moonWitch",
  "batMask",
  "pumpkinBeret",
  "santaHat",
  "jingleElf",
  "reindeer",
  "bunnyEars",
  "spaceAntennae",
  "foxMask",
  "mushroomCap",
  "jesterHat",
  "frostCrown",
  "voodooTopHat",
  "devilHorns",
  "pumpkinGlasses",
  "pirateTricorn",
  "pirateCaptain",
  "pirateBandana",
  "santaBeard"
]);
var selfiePage = z2.object({
  type: z2.literal("selfie"),
  title: z2.optional(z2.string()),
  instructions: z2.optional(z2.string()),
  lenses: z2.optional(z2.array(selfieLens).min(1)),
  defaultLens: z2.optional(selfieLens),
  // Face-tracking tuning overrides. The player also honours the live debug
  // URL params (?faceZGain, ?occluder) which win over these persisted values.
  faceZGain: z2.optional(z2.number()),
  occluderRadii: z2.optional(z2.tuple([z2.number(), z2.number(), z2.number()])),
  occluderCenter: z2.optional(z2.tuple([z2.number(), z2.number(), z2.number()]))
});
var arShooterTargetId = z2.enum([
  "pumpkin",
  "ghost",
  "bat",
  "spider",
  "sweet",
  "cauldron",
  "witchHat",
  "flamingSkull"
]);
var AR_SHOOTER_TARGET_IDS = arShooterTargetId.options;
var AR_SHOOTER_TARGET_INFO = {
  pumpkin: { id: "pumpkin", emoji: "\u{1F383}", label: "Pumpkin", plural: "pumpkins" },
  ghost: { id: "ghost", emoji: "\u{1F47B}", label: "Ghost", plural: "ghosts" },
  bat: { id: "bat", emoji: "\u{1F987}", label: "Bat", plural: "bats" },
  spider: { id: "spider", emoji: "\u{1F577}\uFE0F", label: "Spider", plural: "spiders" },
  sweet: { id: "sweet", emoji: "\u{1F36C}", label: "Sweet", plural: "sweets" },
  cauldron: {
    id: "cauldron",
    emoji: "\u2697\uFE0F",
    label: "Cauldron",
    plural: "cauldrons"
  },
  witchHat: {
    id: "witchHat",
    emoji: "\u{1F9D9}",
    label: "Witch hat",
    plural: "witch hats"
  },
  flamingSkull: {
    id: "flamingSkull",
    emoji: "\u{1F480}",
    label: "Flaming skull",
    plural: "flaming skulls"
  }
};
var AR_SHOOTER_TARGET_CATALOG = AR_SHOOTER_TARGET_IDS.map((id) => AR_SHOOTER_TARGET_INFO[id]);
var DEFAULT_AR_SHOOTER_TARGETS = [
  "pumpkin"
];
var arShooterEncounter = z2.enum(["classic", "rift"]);
var arShooterMode = z2.enum(["blast", "defend"]);
var arShooterGame = baseGame.extend({
  type: z2.literal("arShooterGame"),
  variant: z2.enum(["pumpkins", "balloons"]),
  targetScore: z2.optional(z2.number()),
  fallbackMode: z2.optional(z2.boolean()),
  // Blaster look (see gadgetTheme). Omitted = 'classic', the original toy colours.
  theme: z2.optional(gadgetTheme),
  // Which things float in for the blaster. Omitted/empty = ['pumpkin'], which
  // is what every page authored before this field did. Ignored by the
  // 'balloons' variant, which always throws at a balloon.
  targets: z2.optional(
    z2.array(arShooterTargetId).min(1).max(AR_SHOOTER_TARGET_IDS.length)
  ),
  // When the game is won a treasure chest appears in front of the player;
  // tapping it opens it. Omitted = no chest.
  rewardChest: z2.optional(z2.boolean()),
  // Plain text revealed when the chest opens (a clue, a code word); shown on
  // the completion card too. Only used with rewardChest.
  rewardText: z2.optional(z2.string().max(200)),
  // How the game is framed. 'rift': a swirling portal opens in the air ahead
  // of the player, the targets pour out of it and it snaps shut on the win.
  // Omitted =
  // 'classic', targets simply float in, as every earlier page did.
  encounter: z2.optional(arShooterEncounter),
  // What the blaster is for. 'defend': a crystal lands on the ground ahead and
  // the targets drift towards it; one reaching it costs a life. Omitted =
  // 'blast', shoot them before the score runs out, as before.
  mode: z2.optional(arShooterMode),
  // Defend mode only: how many targets may reach the crystal before it
  // shatters and the wave starts over. Player-side default 3.
  lives: z2.optional(z2.number().int().min(1).max(9))
});
var KNOWN_AR_SHOOTER_TARGETS = new Set(AR_SHOOTER_TARGET_IDS);
function resolveShooterTargets(page2) {
  const raw = page2?.targets;
  if (!raw || raw.length === 0) return [...DEFAULT_AR_SHOOTER_TARGETS];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const id of raw) {
    if (seen.has(id) || !KNOWN_AR_SHOOTER_TARGETS.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out.length > 0 ? out : [...DEFAULT_AR_SHOOTER_TARGETS];
}
var sliceGame = baseGame.extend({
  type: z2.literal("sliceGame"),
  // Object skins launched through the scene (fruit, eggs, baubles…). At least
  // one is required so there is always something to slice.
  images: z2.array(z2.string()).min(1),
  targetScore: z2.number(),
  // Slicing one of these ends the round in the wrong-answer state
  // (classic Fruit-Ninja bomb). Optional — omit for a no-fail game.
  bombImages: z2.optional(z2.array(z2.string())),
  // Tuning (all optional; the component supplies sensible defaults).
  spawnIntervalMs: z2.optional(z2.number()),
  objectSpeed: z2.optional(z2.number()),
  gravity: z2.optional(z2.number()),
  maxOnScreen: z2.optional(z2.number()),
  // Fraction of spawned objects that are bombs (0 = none, 1 = all). Optional;
  // the component defaults to a conservative 0.1 when unset, and always 0
  // when no bombImages are configured regardless of this value.
  bombRatio: z2.optional(z2.number().min(0).max(1))
});
var whackGame = baseGame.extend({
  type: z2.literal("whackGame"),
  // Pop-up character skins (moles, ghosts, elves, chicks…). At least one.
  images: z2.array(z2.string()).min(1),
  targetScore: z2.number(),
  // Tapping one of these penalises the score (optional decoys).
  decoyImages: z2.optional(z2.array(z2.string())),
  // Tuning (all optional; the component supplies sensible defaults).
  holeCount: z2.optional(z2.number()),
  popDurationMs: z2.optional(z2.number()),
  spawnIntervalMs: z2.optional(z2.number())
});
var targetTossGame = baseGame.extend({
  type: z2.literal("targetTossGame"),
  // Target skins the player flicks a projectile at. At least one is required
  // so there is always something to aim for.
  targetImages: z2.array(z2.string()).min(1),
  // Optional custom projectile skin; falls back to a simple ball when omitted.
  projectileImage: z2.optional(z2.string()),
  targetScore: z2.number(),
  // When true the target drifts side to side, making it harder to hit.
  movingTarget: z2.optional(z2.boolean()),
  // Number of throws (lives) before the round fails. Omit for unlimited throws.
  throws: z2.optional(z2.number())
});
var stackGame = baseGame.extend({
  type: z2.literal("stackGame"),
  // Optional block texture; when omitted a solid colour is used instead.
  blockImage: z2.optional(z2.string()),
  // Fallback/base block colour (CSS colour string) used when no image is set.
  blockColor: z2.optional(z2.string()),
  // Target tower height (blocks placed) needed to complete the game.
  targetScore: z2.number(),
  // Base horizontal slide speed; ramps up as the tower grows. Optional.
  speed: z2.optional(z2.number())
});
var spinWheelSegment = z2.object({
  label: z2.optional(z2.string()),
  value: z2.number(),
  color: z2.optional(z2.string())
});
var spinWheelGame = baseGame.extend({
  type: z2.literal("spinWheelGame"),
  // Wheel segments (min 2). Each awards its `value` when the wheel lands on it.
  segments: z2.array(spinWheelSegment).min(2),
  // Running total the player must reach (across multiple spins) to complete.
  targetScore: z2.number()
});
var basketCatchGame = baseGame.extend({
  type: z2.literal("basketCatchGame"),
  // Skins for the items that fall from the top. At least one is required so
  // there is always something to catch.
  itemImages: z2.array(z2.string()).min(1),
  // Optional custom basket skin; falls back to a simple bucket when omitted.
  basketImage: z2.optional(z2.string()),
  // Catches needed to complete the game.
  targetScore: z2.number(),
  // Missed items allowed before the round fails (defaults to 3). Running out
  // triggers the wrong-answer state.
  lives: z2.optional(z2.number()),
  // When true the basket can also be steered by tilting the device
  // (DeviceOrientation), with a graceful drag fallback when unavailable.
  useTilt: z2.optional(z2.boolean()),
  // Tuning (all optional; the component supplies sensible defaults).
  fallSpeed: z2.optional(z2.number()),
  spawnIntervalMs: z2.optional(z2.number()),
  // Shape of the fallback 3D catcher shown when no `basketImage` skin is set.
  // Defaults to 'basket' when unset.
  catcherType: z2.optional(z2.union([z2.literal("basket"), z2.literal("bucket")]))
});
var memoryPairsGame = baseGame.extend({
  type: z2.literal("memoryPairsGame"),
  // One image per pair (min 2). Each is duplicated to form a face-down grid.
  images: z2.array(z2.string()).min(2),
  // Optional fixed column count; a balanced grid is derived when omitted.
  gridColumns: z2.optional(z2.number()),
  // Optional cap on how many of `images` are used as pairs.
  pairCount: z2.optional(z2.number()),
  // Optional move (flip-pair) limit; exceeding it fails the round. Omit for a
  // relaxed, win-only game (the museum-friendly default).
  moveLimit: z2.optional(z2.number())
});
var tiltMazeGame = baseGame.extend({
  type: z2.literal("tiltMazeGame"),
  // Optional ball/egg skin; falls back to a simple sphere when omitted.
  ballImage: z2.optional(z2.string()),
  // Maze grid size (cells per side). A solvable maze is generated. Default ~6.
  mazeSize: z2.optional(z2.number()),
  // Wall colour (CSS colour string). Optional; a sensible default is used.
  wallColor: z2.optional(z2.string()),
  // Optional countdown (seconds); reaching zero before the goal fails the
  // round. Omit for a relaxed, win-only game.
  timeLimitSec: z2.optional(z2.number())
});
var luminaTheme = z2.enum(["fireflies", "snow", "petals", "embers"]);
var luminaTarget = z2.enum([
  "orb",
  "egg",
  "bauble",
  // Legacy variants kept so older saved pages still parse. The 2D redesign
  // renders these as the decorated orb; new pages should pick orb/egg/bauble.
  "snowman",
  "present",
  "chest"
]);
var luminaGame = baseGame.extend({
  type: z2.literal("luminaGame"),
  // Palette for the particles and the background wash. Defaults to 'fireflies'
  // (warm gold on a soft dawn sky) when omitted.
  theme: z2.optional(luminaTheme),
  // The central object the swarm charges to life, then cracks open. A decorated
  // 'egg' (Easter) or 'bauble' (Christmas), or a glowing 'orb'. Defaults to
  // 'orb' when omitted.
  target: z2.optional(luminaTarget),
  // Deprecated/ignored: the grove used to scatter this many lanterns before the
  // single-target redesign. Kept optional so older saved pages still parse.
  lanternCount: z2.optional(z2.number()),
  // Particle count. Capped in the player for mobile (~120–320).
  moteCount: z2.optional(z2.number()),
  // Optional photographic backdrop shown BEHIND the particle field instead of
  // the generated light-gradient sky. Distinct from `backgroundImage`, which
  // styles the instructions/complete cards.
  sceneBackgroundImage: z2.optional(z2.string()),
  // Optional reveal image, mirroring the Reveal page: when the object is fully
  // charged it cracks open and this image bursts out to fill the screen, then
  // the trail advances to the next page. Set it to the same image used on the
  // following page (e.g. a Layout01) so the picture reads as having been
  // *inside* the egg/bauble. When omitted, charging shows the completion card.
  revealImage: z2.optional(z2.string())
});
var melodyInstrument = z2.enum(["strings", "piano", "drums", "chimes"]);
var MELODY_NOTE_COUNTS = {
  strings: 4,
  piano: 6,
  drums: 4,
  chimes: 5
};
var MELODY_MAX_NOTE_INDEX = Math.max(...Object.values(MELODY_NOTE_COUNTS)) - 1;
var melodyGamePage = z2.object({
  type: z2.literal("melodyGame"),
  instrument: melodyInstrument,
  // The melody to echo back: 1–8 note indices. Each index must be a valid
  // note on the chosen instrument (checked in superRefine). A pentatonic
  // scale means any sequence — and free play — always sounds good.
  sequence: z2.array(z2.number().int().min(0).max(MELODY_MAX_NOTE_INDEX)).min(1).max(8),
  // Optional story character shown as the melody-giver. When ABSENT the
  // player shows a built-in animated musical sprite instead.
  characterImage: z2.optional(z2.string()),
  // Whether the "Just play" / "Play freely" free-play affordances appear.
  // Player-side default true.
  allowFreePlay: z2.optional(z2.boolean()),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string())
}).superRefine((val, ctx) => {
  const noteCount = MELODY_NOTE_COUNTS[val.instrument];
  val.sequence.forEach((note, index) => {
    if (note >= noteCount) {
      ctx.addIssue({
        code: "custom",
        message: `Note ${note} is out of range for ${val.instrument} (valid notes are 0\u2013${noteCount - 1})`,
        path: ["sequence", index]
      });
    }
  });
});
var locationCheckPage = z2.object({
  type: z2.literal("locationCheck"),
  geofenceRadius: z2.number(),
  image: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  title: z2.optional(z2.string()),
  content: z2.optional(z2.string())
});
var qrCheckPage = z2.object({
  type: z2.literal("qrCheck"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  // The exact decoded text the scan must match. Author pastes the string/URL
  // the target QR decodes to (they scan it with any phone camera to find out).
  // Trim first so a whitespace-only value (" ") is rejected, not stored.
  expectedValue: z2.string().trim().min(1),
  // How the decoded text is compared. Player-side default is 'exact'.
  matchMode: z2.optional(z2.enum(["exact", "contains"])),
  // Player-side default false (case-insensitive comparison).
  caseSensitive: z2.optional(z2.boolean()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // Shown transiently when a DIFFERENT (non-matching) code is scanned. Plain
  // text (NOT rich): rendered as escaped text, kept out of the rich-text lists.
  wrongScanTitle: z2.optional(z2.string()),
  wrongScanText: z2.optional(z2.string())
});
var arMarkerObject = z2.enum(["chest", "orb", "snowman", "present"]);
var arMarkerMount = z2.enum(["auto", "wall", "floor"]);
var arMarkerDisplay = z2.enum(["object", "window"]);
var arMarkerWindowScene = z2.enum(["starfield", "grove", "aurora"]);
var arMarkerPage = z2.object({
  type: z2.literal("arMarker"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // The procedural object anchored to the sign.
  object: arMarkerObject,
  // The printed frame's outer side length in millimetres — REQUIRED because it
  // is the metric scale reference the tracker uses to recover a real-world pose.
  // Must match what was actually printed.
  markerSizeMm: z2.number().int().min(50).max(1e3),
  // Placement mode. Defaults to 'auto' (classify from the tracker) in the player.
  mount: z2.optional(arMarkerMount),
  // Real-world height of the object in metres. The marker pose is already
  // metric (the printed size fixes scale), so when set the object renders
  // life-size — e.g. 1.6 for a deer, 4 for a dinosaur — instead of the default
  // ~2× marker-size heuristic. Absent → the heuristic. Bounds keep it sensible:
  // very tall objects on a small sign amplify tracking noise.
  worldHeightM: z2.optional(z2.number().min(0.1).max(6)),
  // Keep the object anchored in the room so the player can walk around it,
  // instead of it staying locked to the sign. Uses SLAM + the marker's metric
  // scale (see docs/AR-PERSISTENT-ANCHORING.md). Absent/false → the object
  // stays locked to the sign (today's behaviour); when on but SLAM isn't
  // tracking or scale hasn't converged, it falls back to that same behaviour.
  persistentAnchor: z2.optional(z2.boolean()),
  // Seconds of cumulative locked tracking before the Continue affordance
  // appears. Player-side default 4. Non-negative — a negative dwell would
  // satisfy the gate immediately (cumulativeMs >= dwellSeconds*1000 at 0).
  dwellSeconds: z2.optional(z2.number().min(0)),
  // Display mode. Omitted / 'object' = the original behaviour (a 3D object
  // anchored to the sign); 'window' turns the sign into a stencil-buffer portal.
  // Additive and optional so every existing arMarker page keeps parsing and
  // renders exactly as before.
  display: z2.optional(arMarkerDisplay),
  // Window-mode only: which procedural scene renders behind the portal. Ignored
  // in object mode and when `panoImageUrl` is set (the pano wins).
  windowScene: z2.optional(arMarkerWindowScene),
  // Window-mode only: a 360°/equirectangular image shown as a photo sphere
  // behind the window (the "time window" use case). When set it wins over
  // `windowScene`; when both are empty a default procedural scene is used.
  panoImageUrl: z2.optional(z2.string())
});
var encounterCreature = z2.enum(["fairy"]);
var fairyElement = z2.enum([
  "nature",
  "ice",
  "fire",
  "sparkle",
  "twilight"
]);
var fairyHairStyle = z2.enum(["long", "bun", "pixie"]);
var fairyDressStyle = z2.enum(["petal", "tunic", "gown"]);
var fairyWingStyle = z2.enum(["butterfly", "dragonfly", "leaf"]);
var fairyAppearance = z2.object({
  element: z2.optional(fairyElement),
  skinTone: z2.optional(z2.string()),
  hairColor: z2.optional(z2.string()),
  hairStyle: z2.optional(fairyHairStyle),
  dressColor: z2.optional(z2.string()),
  dressStyle: z2.optional(fairyDressStyle),
  wingColor: z2.optional(z2.string()),
  wingStyle: z2.optional(fairyWingStyle),
  glowColor: z2.optional(z2.string())
});
var encounterAnchor = z2.enum(["area", "target"]);
var encounterTargetKind = z2.enum(["printedFrame", "photo"]);
var encounterPlacement = z2.enum(["auto", "ground", "flying"]);
var fairyEncounterPage = z2.object({
  type: z2.literal("fairyEncounter"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // Which creature appears. Player-side default 'fairy'.
  creature: z2.optional(encounterCreature),
  // Shown in the HUD once found ("You found Elowen!"). Plain text.
  creatureName: z2.optional(z2.string()),
  appearance: z2.optional(fairyAppearance),
  // Player-side default 'area'.
  anchor: z2.optional(encounterAnchor),
  // Area mode only. Player-side default 'auto'.
  placement: z2.optional(encounterPlacement),
  // Creature body height in metres. Player-side default 0.35 (a knee-high
  // fairy). Bounded: tiny is invisible, huge amplifies tracking noise.
  creatureHeightM: z2.optional(z2.number().min(0.1).max(2)),
  // Target mode only. Which target kind to track; default 'printedFrame'.
  targetKind: z2.optional(encounterTargetKind),
  // printedFrame targets: the printed frame's outer side length in mm — the
  // metric scale reference (must match what was actually printed).
  markerSizeMm: z2.optional(z2.number().int().min(50).max(1e3)),
  // photo targets: a straight-on photo of the poster/sign to track.
  targetImageUrl: z2.optional(z2.string()),
  // photo targets: the poster's approximate physical width in mm. Only sets
  // the apparent scale/distance of the fairy (accuracy is secondary in photo
  // mode); player-side default 300.
  targetWidthMm: z2.optional(z2.number().int().min(50).max(2e3)),
  // Seconds the creature must stay found before Continue appears.
  // Player-side default 4.
  dwellSeconds: z2.optional(z2.number().min(0))
}).superRefine((val, ctx) => {
  if (val.anchor !== "target") return;
  const kind = val.targetKind ?? "printedFrame";
  if (kind === "printedFrame" && val.markerSizeMm === void 0) {
    ctx.addIssue({
      code: "custom",
      message: "markerSizeMm is required when anchoring to a printed frame sign",
      path: ["markerSizeMm"]
    });
  }
  if (kind === "photo" && !val.targetImageUrl) {
    ctx.addIssue({
      code: "custom",
      message: "targetImageUrl is required when anchoring to a photo target",
      path: ["targetImageUrl"]
    });
  }
});
var numberLockStyle = z2.enum([
  "keypad",
  "briefcase",
  "padlock",
  "safe",
  // A wooden treasure chest held shut by a combination padlock on the hasp;
  // the lid lifts on unlock. Also the lock the Treasure Chest page hands off to.
  "chest"
]);
var NUMBER_LOCK_MIN_DIGITS = 1;
var NUMBER_LOCK_MAX_DIGITS = 6;
var NUMBER_LOCK_CODE_PATTERN = /^\d{1,6}$/;
var NUMBER_LOCK_SKIPPED_ANSWER = "__skipped__";
var numberLockPage = z2.object({
  type: z2.literal("numberLock"),
  title: z2.optional(z2.string()),
  // The correct code: 1–6 digits, digits only (a year like "1874" typically).
  code: z2.string().regex(NUMBER_LOCK_CODE_PATTERN, {
    message: "Code must be 1 to 6 digits"
  }),
  // Which lock the player sees. Defaults to 'keypad' when omitted.
  lockStyle: z2.optional(numberLockStyle),
  // Where to find the number — shown on the intro card before the lock.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // Short prompt shown above the entry readout (and as the keypad's idle
  // display text), e.g. "What year is on the plaque?".
  lockPrompt: z2.optional(z2.string()),
  // Short text engraved on the lock model itself: the briefcase plate, the
  // padlock's maker's tag or the safe name-plate. Empty = no plate.
  plateText: z2.optional(z2.string()),
  // Optional hint revealed after `hintAfterAttempts` wrong tries (default 3).
  hint: z2.optional(z2.string()),
  hintAfterAttempts: z2.optional(z2.number().int().min(1).max(20)),
  // Whether the player may skip past the lock. Defaults to true.
  allowSkip: z2.optional(z2.boolean()),
  completeTitle: z2.optional(z2.string()),
  completeText: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  // Optional Reveal-style payoff: when the lock opens, this image bursts out of
  // it to fill the screen and the trail advances straight to the next page.
  // Set it to the same image as the following page (e.g. a Layout01) so the
  // picture reads as having been *inside* the safe/briefcase.
  revealImage: z2.optional(z2.string()),
  // The code the player got in with — set client-side on unlock (never
  // authored) so a refresh doesn't re-lock the door; mirrors question.userAnswer.
  userAnswer: z2.optional(z2.string())
});
var CIPHER_LOCK_MIN_SHIFT = 1;
var CIPHER_LOCK_MAX_SHIFT = 25;
var CIPHER_LOCK_MAX_ANSWER_LETTERS = 24;
var CIPHER_LOCK_ANSWER_PATTERN = /^(?=(?:[^A-Za-z]*[A-Za-z]){2})[A-Za-z ]+$/;
var cipherLockPage = z2.object({
  type: z2.literal("cipherLock"),
  title: z2.optional(z2.string()),
  // The plaintext the player must decode to, e.g. "WELL HOUSE". Compared
  // case- and space-insensitively.
  answer: z2.string().trim().regex(CIPHER_LOCK_ANSWER_PATTERN, {
    message: "Answer must be letters and spaces only, at least two letters"
  }).refine(
    (s) => s.replace(/[^A-Za-z]/g, "").length <= CIPHER_LOCK_MAX_ANSWER_LETTERS,
    {
      message: `Answer can have at most ${CIPHER_LOCK_MAX_ANSWER_LETTERS} letters`
    }
  ),
  // The Caesar shift (1–25) that turns the answer into the shown ciphertext —
  // the number the player must find on-site (or deduce by turning the wheel).
  shift: z2.number().int().min(CIPHER_LOCK_MIN_SHIFT).max(CIPHER_LOCK_MAX_SHIFT),
  // Where to find the key — shown on the intro card.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // Short label by the wheel (e.g. "Set the key").
  lockPrompt: z2.optional(z2.string()),
  // Optional hint revealed after `hintAfterAttempts` wrong tries (default 3).
  hint: z2.optional(z2.string()),
  hintAfterAttempts: z2.optional(z2.number().int().min(1).max(20)),
  allowSkip: z2.optional(z2.boolean()),
  completeTitle: z2.optional(z2.string()),
  completeText: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  // Optional Reveal-style payoff (see numberLock.revealImage).
  revealImage: z2.optional(z2.string()),
  // Client-only: the normalised decoded answer on success, or the skip
  // marker — mirrors question.userAnswer / numberLock.userAnswer.
  userAnswer: z2.optional(z2.string())
});
var showcase3dModel = z2.enum([
  "candyCane",
  "bauble",
  "star",
  "present"
]);
var showcase3dEnvironment = z2.enum([
  "studio",
  "festive",
  "sunset",
  "moonlight"
]);
var showcase3dParticles = z2.enum([
  "sparkles",
  "snow",
  "confetti",
  "none"
]);
var SHOWCASE3D_MIN_SCALE = 0.25;
var SHOWCASE3D_MAX_SCALE = 4;
var showcase3dPage = z2.object({
  type: z2.literal("showcase3d"),
  title: z2.optional(z2.string()),
  content: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // Screen-reader description of the object; the canvas itself is
  // decorative, so this is the only thing assistive tech gets.
  altText: z2.optional(z2.string()),
  allowNavigation: z2.optional(z2.boolean()),
  // Built-in model (default candyCane). Ignored while a modelUrl loads
  // successfully, and the fallback if that load fails.
  model: z2.optional(showcase3dModel),
  // A .glb on the CDN (media library upload). Any size: the scene centres
  // and fits it to the view automatically, then applies modelScale.
  modelUrl: z2.optional(z2.string()),
  // Multiplier on the auto-fit size (default 1).
  modelScale: z2.optional(
    z2.number().min(SHOWCASE3D_MIN_SCALE).max(SHOWCASE3D_MAX_SCALE)
  ),
  environment: z2.optional(showcase3dEnvironment),
  particles: z2.optional(showcase3dParticles),
  // Idle spin while the player isn't dragging (default true).
  autoRotate: z2.optional(z2.boolean()),
  // Accent colours for the built-in models (CSS colour strings).
  primaryColor: z2.optional(z2.string()),
  secondaryColor: z2.optional(z2.string())
});
var crackerRevealPage = z2.object({
  type: z2.literal("crackerReveal"),
  title: z2.optional(z2.string()),
  // Short prompt shown under the cracker (default "Pull the cracker!").
  instructions: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // Wrapping-paper colours (CSS colour strings); default festive red/gold.
  primaryColor: z2.optional(z2.string()),
  secondaryColor: z2.optional(z2.string()),
  // Optional picture that bursts out of the cracker before the trail moves
  // on (mirrors pageReveal01.revealedImage).
  revealImage: z2.optional(z2.string()),
  altText: z2.optional(z2.string())
});
var signalDetectorPage = z2.object({
  type: z2.literal("signalDetector"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // Detector look (see gadgetTheme). Player-side default 'classic'.
  theme: z2.optional(gadgetTheme),
  // What the detector is tuned to, plain text, e.g. "pumpkin magic" or "the
  // ghost's giggle". Used in HUD copy ("Faint trace of pumpkin magic…").
  // Player-side default "the signal".
  signalName: z2.optional(z2.string()),
  // How far from the player the hidden spot is placed, in metres. Player-side
  // default 2. Bounded so the walk stays inside a tracker's comfort range and
  // a small child's patience.
  hideDistanceM: z2.optional(z2.number().min(1).max(4)),
  // Radius around the hidden spot that counts as found, in metres. Player-side
  // default 0.6. Deliberately tolerant: scale is estimated on iOS.
  foundRadiusM: z2.optional(z2.number().min(0.3).max(1.5))
}).superRefine((val, ctx) => {
  const foundRadiusM = val.foundRadiusM ?? 0.6;
  const hideDistanceM = val.hideDistanceM ?? 2;
  if (foundRadiusM * 2 > hideDistanceM) {
    ctx.addIssue({
      code: "custom",
      message: "Found radius must be at most half the hide distance, so there is something to walk",
      path: ["foundRadiusM"]
    });
  }
});
var treasureChestPage = z2.object({
  type: z2.literal("treasureChest"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // What the player is hunting, plain text, used in HUD copy ("You found the
  // Pumpkin King's chest!"). Player-side default "the treasure chest".
  chestName: z2.optional(z2.string()),
  // How far ahead the chest is placed, in metres. Player-side default 2.2.
  hideDistanceM: z2.optional(z2.number().min(1).max(4)),
  // How close the player must get before "Open the chest" appears, in metres.
  // Player-side default 1.
  openRadiusM: z2.optional(z2.number().min(0.5).max(2)),
  // The lock. Same contract as numberLock.code: 1 to 6 digits, compared
  // digit-for-digit (leading zeros count). Ships to the client like question.answer.
  code: z2.string().regex(NUMBER_LOCK_CODE_PATTERN, {
    message: "Code must be 1 to 6 digits"
  }),
  // Short prompt above the entry readout, e.g. "What year is on the plaque?".
  lockPrompt: z2.optional(z2.string()),
  // Short text engraved on the chest's brass name-plate. Empty = no plate.
  plateText: z2.optional(z2.string()),
  hint: z2.optional(z2.string()),
  hintAfterAttempts: z2.optional(z2.number().int().min(1).max(20)),
  // Whether the player may skip past the hunt or the lock. Defaults to true.
  allowSkip: z2.optional(z2.boolean()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  // Reveal-style payoff: bursts out of the opened chest and the trail advances
  // straight to the next page (see numberLock.revealImage).
  revealImage: z2.optional(z2.string()),
  // Set client-side on unlock (never authored); mirrors numberLock.userAnswer.
  userAnswer: z2.optional(z2.string())
}).superRefine((val, ctx) => {
  const openRadiusM = val.openRadiusM ?? 1;
  const hideDistanceM = val.hideDistanceM ?? 2.2;
  if (openRadiusM * 1.5 > hideDistanceM) {
    ctx.addIssue({
      code: "custom",
      message: "Open radius must leave room to walk up to the chest (at most two thirds of the hide distance)",
      path: ["openRadiusM"]
    });
  }
});
var signRevealObject = z2.enum([
  "pumpkin",
  "key",
  "orb",
  "chest",
  "present",
  "snowman"
]);
var SIGN_REVEAL_MAX_TEXT_CHARS = 16;
var signRevealPage = z2.object({
  type: z2.literal("signReveal"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // Scanner look while searching (see gadgetTheme). Player default 'classic'.
  theme: z2.optional(gadgetTheme),
  // Short plain-text hint over the live view, e.g. "Scan the old sign by the gate".
  scannerHint: z2.optional(z2.string()),
  // Photo targets only: show the reference photo on a second screen under
  // the live view so the player knows what to look for. Defaults to true.
  showTargetPreview: z2.optional(z2.boolean()),
  // Which physical target to track; default 'printedFrame'.
  targetKind: z2.optional(encounterTargetKind),
  // printedFrame targets: the printed frame's outer side length in mm, the
  // metric scale reference (must match what was actually printed).
  markerSizeMm: z2.optional(z2.number().int().min(50).max(1e3)),
  // photo targets: a straight-on photo of the poster/sign to track.
  targetImageUrl: z2.optional(z2.string()),
  // photo targets: the poster's approximate physical width in mm; sets the
  // apparent scale of the reveal. Player-side default 300.
  targetWidthMm: z2.optional(z2.number().int().min(50).max(2e3)),
  // The MacGuffin. Short text shown on a glowing plaque floating in front of
  // the sign (a code such as "1887", a word, a rune). Plain text.
  revealText: z2.optional(z2.string().max(SIGN_REVEAL_MAX_TEXT_CHARS)),
  // And/or a procedural object attached to the sign.
  revealObject: z2.optional(signRevealObject),
  // Seconds of cumulative tracked time before Continue appears. Player
  // default 4. Non-negative for the same reason as arMarker.dwellSeconds.
  dwellSeconds: z2.optional(z2.number().min(0))
}).superRefine((val, ctx) => {
  const kind = val.targetKind ?? "printedFrame";
  if (kind === "printedFrame" && val.markerSizeMm === void 0) {
    ctx.addIssue({
      code: "custom",
      message: "markerSizeMm is required when tracking a printed frame sign",
      path: ["markerSizeMm"]
    });
  }
  if (kind === "photo" && !val.targetImageUrl) {
    ctx.addIssue({
      code: "custom",
      message: "targetImageUrl is required when tracking a photo target",
      path: ["targetImageUrl"]
    });
  }
  if (!val.revealText?.trim() && !val.revealObject) {
    ctx.addIssue({
      code: "custom",
      message: "Set some reveal text, a reveal object, or both",
      path: ["revealText"]
    });
  }
});
var spellShape = z2.enum(["circle", "triangle", "square", "star"]);
var wandStyle = z2.enum(["wand", "fairy", "blaster"]);
var spellCastPage = z2.object({
  type: z2.literal("spellCast"),
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string()),
  // The shape to draw. Player-side default 'circle' (the easiest).
  shape: z2.optional(spellShape),
  // The wand in the player's hand. Player-side default 'wand'.
  wand: z2.optional(wandStyle),
  // Particle colours, and the blaster's paint (see gadgetTheme). Player-side
  // default 'classic'.
  theme: z2.optional(gadgetTheme),
  // What is being cast, plain text, e.g. "the portal spell" or "the pumpkin
  // charm". Used in the on-screen copy ("Draw a star to cast the portal
  // spell"). Player-side default "the spell".
  spellName: z2.optional(z2.string()),
  // Show a faint outline of the shape in the air for the player to trace.
  // For younger children. Player-side default false.
  showGuide: z2.optional(z2.boolean())
});
var photoCharacterId = z2.enum([
  "polarBear",
  "fairy",
  "fox",
  "bunny",
  "penguin",
  "robot",
  "dragon",
  "frostDragon",
  "gingerbreadUnicorn",
  "ghost",
  "owl",
  "reindeer",
  "elf",
  "robin",
  "gingerbread",
  "pumpkin",
  "monster",
  "goblin",
  "werewolf",
  "skeletonMage",
  "witch",
  "broomWitch",
  "skeleton",
  "frankenstein",
  "zombie",
  "santa",
  "nutcracker",
  "bat"
]);
var feedableCharacterId = z2.enum([
  "polarBear",
  "pumpkin",
  "monster",
  "snowman",
  "frog",
  "dragon",
  "frostDragon",
  "gingerbreadUnicorn",
  "reindeer",
  "elf",
  "goblin",
  "werewolf",
  "skeletonMage",
  "witch",
  "broomWitch",
  "skeleton",
  "frankenstein",
  "zombie",
  "santa",
  "nutcracker",
  "bat"
]);
var arShellFields = {
  title: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  completeTitle: z2.optional(z2.string()),
  // Rich text (HTML) — sanitized write-time via RICH_TEXT_PAGE_FIELDS.
  completeText: z2.optional(z2.string())
};
var snapChaseARPage = z2.object({
  type: z2.literal("snapChaseAR"),
  ...arShellFields,
  character: spriteSpec,
  // Sprite width in metres in the world. Player-side default 0.9.
  characterSizeM: z2.optional(z2.number().min(0.2).max(3)),
  // 'fly' hovers above the ground anchor (default); 'ground' runs around it.
  locomotion: z2.optional(z2.enum(["fly", "ground"])),
  // Height of a flying character above the ground, metres. Default 1.3.
  flyHeightM: z2.optional(z2.number().min(0.3).max(4)),
  // How much of the sprite must be on screen for the shutter to fire (0..1).
  // Player-side default 0.3.
  passVisibleRatio: z2.optional(z2.number().min(0.05).max(1)),
  // Caption printed on the photo. Plain text. Default "Snapped on a Magical Trail!"
  photoCaption: z2.optional(z2.string()),
  fallbackMode: z2.optional(z2.boolean())
});
var creaturePhotoPage = z2.object({
  type: z2.literal("creaturePhoto"),
  ...arShellFields,
  // Which character appears. Player-side default 'fox'.
  creature: z2.optional(photoCharacterId),
  // Shown in the HUD ("Say hello to Rusty!"). Plain text.
  creatureName: z2.optional(z2.string()),
  // Fairy only: her look (same options as the Fairy Encounter).
  appearance: z2.optional(fairyAppearance),
  // Head-to-toe height in metres. Player-side default = the character's own.
  creatureHeightM: z2.optional(z2.number().min(0.1).max(2)),
  // Caption printed on the photo. Plain text.
  photoCaption: z2.optional(z2.string()),
  fallbackMode: z2.optional(z2.boolean())
});
var feedingGamePage = z2.object({
  type: z2.literal("feedingGame"),
  ...arShellFields,
  // Who is hungry. Player-side default 'pumpkin'.
  creature: z2.optional(feedableCharacterId),
  // Shown in the HUD ("Feed Gordon!"). Plain text.
  creatureName: z2.optional(z2.string()),
  // Successful feeds to win. Player-side default 6.
  targetFeeds: z2.optional(z2.number().int().min(1).max(50)),
  // Head-to-toe height in metres. Player-side default = the character's own.
  creatureHeightM: z2.optional(z2.number().min(0.4).max(3)),
  // When the game is won a treasure chest appears in front of the player;
  // tapping it opens it. Omitted = no chest.
  rewardChest: z2.optional(z2.boolean()),
  // Plain text revealed when the chest opens (a clue, a code word); shown on
  // the completion card too. Only used with rewardChest.
  rewardText: z2.optional(z2.string().max(200)),
  fallbackMode: z2.optional(z2.boolean())
});
var arChompFood = z2.enum([
  "candy",
  "marshmallow",
  "cookie",
  "snowball",
  "fly",
  "carrot",
  "iceCream"
]);
var arChompMouth = z2.enum([
  "classic",
  "mixed",
  "duck",
  "beaver",
  "shark",
  "walrus",
  "windup",
  "monster"
]);
var arChompCamera = z2.enum(["back", "front"]);
var arChompPage = z2.object({
  type: z2.literal("arChomp"),
  ...arShellFields,
  // What gets thrown. Player-side default 'candy'.
  food: z2.optional(arChompFood),
  mouthStyle: z2.optional(arChompMouth),
  // Successful feeds (across every mouth) to win. Player-side default 8.
  targetFeeds: z2.optional(z2.number().int().min(1).max(50)),
  // Most faces given a mouth at once. Player-side default 4. Each extra face
  // costs the phone another landmark pass, so this is capped low.
  maxFaces: z2.optional(z2.number().int().min(1).max(4)),
  // Which camera the game opens on (the player can flip it). 'back' points at
  // family and friends; 'front' is a group selfie. Player-side default 'back'.
  camera: z2.optional(arChompCamera),
  // When true a mouth only takes food while the REAL person's mouth is open,
  // so the people being fed are playing too. Player-side default false.
  openWide: z2.optional(z2.boolean()),
  // Plain text revealed on the completion card (a clue, a code word).
  rewardText: z2.optional(z2.string().max(200))
});
var cauldronIngredientId = z2.enum([
  "eyeball",
  "batWing",
  "toadstool",
  "frog",
  "bone",
  "sweet",
  "spider",
  "feather",
  "potion"
]);
var CAULDRON_INGREDIENT_IDS = cauldronIngredientId.options;
var CAULDRON_INGREDIENT_INFO = {
  eyeball: {
    id: "eyeball",
    emoji: "\u{1F441}\uFE0F",
    label: "Eyeball",
    named: "an eyeball"
  },
  batWing: {
    id: "batWing",
    emoji: "\u{1F987}",
    label: "Bat wing",
    named: "a bat wing"
  },
  toadstool: {
    id: "toadstool",
    emoji: "\u{1F344}",
    label: "Toadstool",
    named: "a toadstool"
  },
  frog: { id: "frog", emoji: "\u{1F438}", label: "Frog", named: "a frog" },
  bone: { id: "bone", emoji: "\u{1F9B4}", label: "Bone", named: "a bone" },
  sweet: { id: "sweet", emoji: "\u{1F36C}", label: "Sweet", named: "a sweet" },
  spider: { id: "spider", emoji: "\u{1F577}\uFE0F", label: "Spider", named: "a spider" },
  feather: { id: "feather", emoji: "\u{1FAB6}", label: "Feather", named: "a feather" },
  potion: {
    id: "potion",
    emoji: "\u{1F9EA}",
    label: "Potion bottle",
    named: "a potion bottle"
  }
};
var CAULDRON_INGREDIENT_CATALOG = CAULDRON_INGREDIENT_IDS.map((id) => CAULDRON_INGREDIENT_INFO[id]);
var CAULDRON_RECIPE_MAX = 5;
var CAULDRON_DECOYS_MAX = 6;
var CAULDRON_RIDDLE_MAX_CHARS = 300;
var cauldronBrewPage = z2.object({
  type: z2.literal("cauldronBrew"),
  ...arShellFields,
  // Cosmetic gadget theme for the HUD accents. Omitted = 'classic'.
  theme: z2.optional(gadgetTheme),
  // The ingredients the brew needs, in recipe order. No repeats.
  recipe: z2.array(cauldronIngredientId).min(1).max(CAULDRON_RECIPE_MAX),
  // Ingredients that float about but do NOT belong in the brew. Omitted =
  // the player picks a few of the remaining kinds itself.
  decoys: z2.optional(z2.array(cauldronIngredientId).max(CAULDRON_DECOYS_MAX)),
  // Whether the recipe has to go in in order. Omitted = any order.
  orderMatters: z2.optional(z2.boolean()),
  // The clue shown over the live view. Plain text.
  riddle: z2.optional(z2.string().max(CAULDRON_RIDDLE_MAX_CHARS)),
  // When the brew is done a treasure chest appears in front of the player;
  // tapping it opens it. Omitted = no chest.
  rewardChest: z2.optional(z2.boolean()),
  // Plain text revealed when the chest opens. Only used with rewardChest.
  rewardText: z2.optional(z2.string().max(200)),
  fallbackMode: z2.optional(z2.boolean())
}).superRefine((val, ctx) => {
  if (new Set(val.recipe).size !== val.recipe.length) {
    ctx.addIssue({
      code: "custom",
      message: "recipe must not repeat an ingredient",
      path: ["recipe"]
    });
  }
  const overlap = (val.decoys ?? []).filter((id) => val.recipe.includes(id));
  if (overlap.length > 0) {
    ctx.addIssue({
      code: "custom",
      message: `decoys must not be in the recipe (${overlap.join(", ")})`,
      path: ["decoys"]
    });
  }
});
var towerBlockKind = z2.enum(["crates", "pumpkins", "ghosts", "mixed"]);
var TOWER_ROWS_MIN = 2;
var TOWER_ROWS_MAX = 10;
var TOWER_SHOTS_MIN = 3;
var TOWER_SHOTS_MAX = 30;
var towerToppleGamePage = z2.object({
  type: z2.literal("towerToppleGame"),
  ...arShellFields,
  // Cosmetic gadget theme for the catapult and HUD. Omitted = 'classic'.
  theme: z2.optional(gadgetTheme),
  // What the tower is built from. Omitted = 'mixed'.
  blocks: z2.optional(towerBlockKind),
  // How many rows tall (four blocks a row). Omitted = 8.
  rows: z2.optional(z2.number().int().min(TOWER_ROWS_MIN).max(TOWER_ROWS_MAX)),
  // Pumpkins in the catapult before the tower is rebuilt. Omitted = 10.
  shots: z2.optional(z2.number().int().min(TOWER_SHOTS_MIN).max(TOWER_SHOTS_MAX)),
  // When the tower is down a treasure chest appears in front of the player;
  // tapping it opens it. Omitted = no chest.
  rewardChest: z2.optional(z2.boolean()),
  // Plain text revealed when the chest opens. Only used with rewardChest.
  rewardText: z2.optional(z2.string().max(200)),
  fallbackMode: z2.optional(z2.boolean())
});
var nfcTapPage = z2.object({
  type: z2.literal("nfcTap"),
  title: z2.optional(z2.string()),
  // The secret the tag must carry. Generated by createDefaultPage; the editor
  // can regenerate it (which retires every tag already written).
  token: z2.string().trim().regex(NFC_TAP_TOKEN_PATTERN, {
    message: "Tag token must be 6 to 32 lowercase letters or digits"
  }),
  // Where the tag is and what the story calls it. Shown on the intro card.
  instructions: z2.optional(z2.string()),
  instructionsImage: z2.optional(z2.string()),
  backgroundImage: z2.optional(z2.string()),
  // Short plain-text line on the scanning stage, e.g. "Hold your phone
  // against the mark".
  scanPrompt: z2.optional(z2.string()),
  // Optional typed code for phones with no NFC at all, printed under a flap
  // on the poster. Compared with normalizeNfcFallbackCode.
  fallbackCode: z2.optional(
    z2.string().trim().max(NFC_TAP_FALLBACK_CODE_MAX_LENGTH)
  ),
  // Author help shown under "Having trouble?", alongside the built-in tips.
  hint: z2.optional(z2.string()),
  allowSkip: z2.optional(z2.boolean()),
  completeTitle: z2.optional(z2.string()),
  completeText: z2.optional(z2.string()),
  completeImage: z2.optional(z2.string()),
  // Optional Reveal-style payoff (see numberLock.revealImage).
  revealImage: z2.optional(z2.string()),
  // Client-only: the normalised token once the tag has been read by any
  // route, or the skip marker. Mirrors numberLock.userAnswer.
  userAnswer: z2.optional(z2.string())
});
var magicMirrorTheme = z2.enum(["halloween", "christmas", "bubbles"]);
var magicMirrorGoal = z2.enum(["popAll", "spellWord"]);
var MAGIC_MIRROR_MAX_WORD_CHARS = 12;
var normalizeMagicMirrorWord = (raw) => (raw ?? "").toUpperCase().replace(/[^A-Z0-9 ]/g, "").replace(/\s+/g, " ").trim().slice(0, MAGIC_MIRROR_MAX_WORD_CHARS).trimEnd();
var magicMirrorPage = z2.object({
  type: z2.literal("magicMirror"),
  ...arShellFields,
  // Which item set floats about. Player-side default 'halloween'.
  theme: z2.optional(magicMirrorTheme),
  // Player-side default 'popAll'.
  goal: z2.optional(magicMirrorGoal),
  // popAll: how many items to pop. Player-side default 10.
  targetCount: z2.optional(z2.number().int().min(3).max(40)),
  // The word or code collected in the slot row. Letters, digits and spaces.
  // Required for 'spellWord'; optional flavour for 'popAll'. Plain text.
  word: z2.optional(z2.string().max(MAGIC_MIRROR_MAX_WORD_CHARS)),
  // Shown prominently on the completion card (a clue, a code). Plain text.
  revealText: z2.optional(z2.string()),
  // Optional cosmetic face lens worn in the mirror; unset means no lens.
  lens: z2.optional(selfieLens),
  // Force tap mode (no pose model), e.g. for a venue with slow phones.
  fallbackMode: z2.optional(z2.boolean())
}).superRefine((val, ctx) => {
  if ((val.goal ?? "popAll") === "spellWord" && !normalizeMagicMirrorWord(val.word)) {
    ctx.addIssue({
      code: "custom",
      message: "A word with at least one letter or digit is required when the goal is to spell one out",
      path: ["word"]
    });
  }
});
var ANSWER_GATE_PAGE_TYPES = [
  "question",
  "numberLock",
  "cipherLock",
  "treasureChest",
  "nfcTap"
];
var PAGE_SCHEMAS_A = [
  pageLayout01,
  pageLayout02,
  questionPage,
  iframePage,
  pageReveal01,
  starburstPage,
  tapTheThingGame,
  slidingTilePuzzleGame,
  imageSliceMatcherGame,
  decoderRingGame,
  visionMatchPage,
  snapChaseGame,
  locationCheckPage,
  audioPage,
  videoPage,
  selfiePage,
  arShooterGame,
  sliceGame,
  whackGame,
  targetTossGame,
  stackGame,
  spinWheelGame,
  basketCatchGame
];
var PAGE_SCHEMAS_B = [
  memoryPairsGame,
  tiltMazeGame,
  luminaGame,
  qrCheckPage,
  arMarkerPage,
  melodyGamePage,
  fairyEncounterPage,
  numberLockPage,
  cipherLockPage,
  showcase3dPage,
  crackerRevealPage,
  signalDetectorPage,
  treasureChestPage,
  signRevealPage,
  spellCastPage,
  snapChaseARPage,
  creaturePhotoPage,
  feedingGamePage,
  nfcTapPage,
  magicMirrorPage,
  cauldronBrewPage,
  towerToppleGamePage,
  objectScanPage,
  arChompPage
];
var pageGroupA = z2.union(PAGE_SCHEMAS_A);
var pageGroupB = z2.union(PAGE_SCHEMAS_B);
var page = z2.union([...PAGE_SCHEMAS_A, ...PAGE_SCHEMAS_B]);
function isAnswerGatePage(page2) {
  return !!page2 && ANSWER_GATE_PAGE_TYPES.includes(page2.type);
}

// src/zodSchemas/trailSchema.ts
import { z as z5 } from "zod";

// src/playerThemes.ts
import { z as z3 } from "zod";
var playerTheme = z3.enum(["classic", "spellbook", "steampunk"]);
var DEFAULT_PLAYER_THEME = "classic";
var PLAYER_THEMES = [
  {
    value: "classic",
    label: "Classic",
    blurb: "The standard Magical Trails look: clean white cards and indigo buttons."
  },
  {
    value: "spellbook",
    label: "Spell book",
    blurb: "Parchment pages, old-book type and deep violet ink. Made for Halloween and anything witchy."
  },
  {
    value: "steampunk",
    label: "Steampunk",
    blurb: "Aged paper, brass and copper, Victorian type. Made for Christmas workshops, inventors and explorers."
  }
];
function resolvePlayerTheme(value) {
  const parsed = playerTheme.safeParse(value);
  return parsed.success ? parsed.data : DEFAULT_PLAYER_THEME;
}

// src/phoneShell/schema.ts
import { z as z4 } from "zod";
var PHONE_THEME_IDS = [
  "modern",
  "blaster",
  "spyfi",
  "steampunk",
  "spellbook"
];
var DEFAULT_PHONE_THEME = "modern";
var PHONE_THEMES = [
  {
    value: "modern",
    label: "Modern",
    blurb: "A clean, present-day phone. Goes with anything.",
    deviceName: "Phone",
    messengerName: "Messages",
    scannerName: "Scanner",
    mapName: "Map",
    accent: "#4f46e5",
    screen: "#f4f4f7",
    pairedPlayerTheme: "classic"
  },
  {
    value: "blaster",
    label: "Blaster",
    blurb: "Chunky toy-gadget plastic in orange and blue, like the pumpkin blaster. Made for junior agents.",
    deviceName: "Agent Pad",
    messengerName: "Comms",
    scannerName: "Blaster Scope",
    mapName: "Mission Map",
    accent: "#ff6a13",
    screen: "#e9f1ff",
    pairedPlayerTheme: "classic"
  },
  {
    value: "spyfi",
    label: "Spy-fi",
    blurb: "Sixties secret-service kit: brushed steel, amber readouts and teleprinter type.",
    deviceName: "Field Communicator",
    messengerName: "Dispatches",
    scannerName: "Microfilm Reader",
    mapName: "Operations Chart",
    accent: "#f2a41c",
    screen: "#14171a",
    pairedPlayerTheme: "classic"
  },
  {
    value: "steampunk",
    label: "Steampunk",
    blurb: "Brass, copper and a painted sky. A hand-built pocket device for inventors and explorers.",
    deviceName: "Aether Companion",
    messengerName: "Telegrams",
    scannerName: "Aetherscope",
    mapName: "Cartograph",
    accent: "#8c4417",
    screen: "#efe3c8",
    pairedPlayerTheme: "steampunk"
  },
  {
    value: "spellbook",
    label: "Spell book",
    blurb: "An enchanted book that writes back: parchment, violet ink and gold leaf.",
    deviceName: "Whispering Book",
    messengerName: "Owl Post",
    scannerName: "Revealing Glass",
    mapName: "Wandering Map",
    accent: "#5b2a86",
    screen: "#f4e9d3",
    pairedPlayerTheme: "spellbook"
  }
];
function resolvePhoneTheme(value) {
  return PHONE_THEME_IDS.includes(value) ? value : DEFAULT_PHONE_THEME;
}
function phoneThemeSpec(value) {
  const theme = resolvePhoneTheme(value);
  return PHONE_THEMES.find((spec) => spec.value === theme) ?? PHONE_THEMES[0];
}
var PHONE_APP_IDS = [
  "messages",
  "map",
  "scanner",
  "codeEntry"
];
function isPhoneAppId(value) {
  return PHONE_APP_IDS.includes(value);
}
var hexColour = z4.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
var phoneColoursSchema = z4.object({
  /** Buttons, the player's own bubbles, badges. */
  accent: z4.optional(z4.string()),
  /** Home screen backdrop, blended into the look's own wallpaper. */
  wallpaper: z4.optional(z4.string())
});
var phoneAppSchema = z4.object({
  /** One of PHONE_APP_IDS; an id this build doesn't know is skipped. */
  id: z4.string(),
  label: z4.optional(z4.string().max(24))
});
var phoneSenderSchema = z4.object({
  name: z4.string().min(1).max(40),
  // Length cap only. The scheme rule (http(s) or a site path) is enforced at
  // SAVE time by validatePhoneSettings, not here: this schema also parses
  // player payloads, whose bundled demo trails use small data-URI avatars.
  avatar: z4.optional(z4.string().max(4096)),
  /** A line under the name in the thread header ("Head of Section"). */
  role: z4.optional(z4.string().max(60))
});
var phoneThreadSchema = z4.object({
  name: z4.string().min(1).max(40),
  avatar: z4.optional(z4.string().max(4096))
});
var phoneSettingsSchema = z4.object({
  /**
   * 'home': a home screen of app icons. 'dock': the icons in a bar under the
   * map. A string, not an enum, like every value here that might grow (see
   * the top of this file); anything else reads as 'home'.
   */
  layout: z4.optional(z4.string()),
  /** One of PHONE_THEME_IDS; unknown → modern. */
  theme: z4.optional(z4.string()),
  colours: z4.optional(phoneColoursSchema),
  /** Order, and per-story names, of the apps. Missing = the defaults. */
  apps: z4.optional(z4.array(phoneAppSchema).max(8)),
  /** Who messages come from, keyed by a short id the author picks. */
  senders: z4.optional(z4.record(z4.string(), phoneSenderSchema)),
  /** Group threads only; a sender's own thread needs no entry. */
  threads: z4.optional(z4.record(z4.string(), phoneThreadSchema))
});
var storyShell = z4.enum(["map", "phone"]);
var phoneLayout = z4.enum(["home", "dock"]);
var messagePresentation = z4.enum(["bubbles", "attachment"]);
var MESSAGE_DELAY_MAX_SECONDS = 3600;
var messageDeliverySchema = z4.object({
  /** 'message' is the only channel today; an unknown one means "no delivery". */
  channel: z4.string(),
  /** Key into `phone.senders`. */
  sender: z4.string().min(1),
  /** Key into `phone.threads`; missing = the sender's own thread. */
  thread: z4.optional(z4.string().min(1)),
  /** Pause between the point unlocking and the message landing. */
  delaySeconds: z4.optional(z4.number().min(0).max(MESSAGE_DELAY_MAX_SECONDS)),
  /**
   * 'bubbles': pages as chat bubbles. 'attachment': the whole point as one
   * openable dossier. Anything else reads as 'bubbles'.
   */
  presentation: z4.optional(z4.string()),
  /** Label on the dossier card ("Case file 7"); missing = the point title. */
  attachmentLabel: z4.optional(z4.string().max(60)),
  /** Code of a story point in the same story to offer as "Show on map". */
  linksTo: z4.optional(z4.string().min(1))
});

// src/zodSchemas/trailSchema.ts
var storyPointConfigSchema = z5.object({
  // Unlock/visibility rules for this point:
  unlockRules: z5.optional(
    z5.union([
      // Show only after specific story points have been completed:
      z5.object({
        type: z5.literal("completedPoints"),
        requiredPoints: z5.array(z5.string())
      }),
      // Show only after all preceding points have been completed:
      z5.object({
        type: z5.literal("completedAllPrecedingPoints")
      })
    ])
  ),
  hiddenIfRulesUnmet: z5.optional(z5.boolean()),
  pagesHiddenBeforeScan: z5.optional(z5.boolean()),
  hideLocationPinOnComplete: z5.optional(z5.boolean()),
  /**
   * Phone shell only: this point arrives as a message instead of a card on
   * the list. Read it through `messageDeliveryFor`, never directly — it only
   * counts on introduction / narrative / conclusion points of a story whose
   * shell is 'phone'.
   */
  delivery: z5.optional(messageDeliverySchema)
});
var storyPointSchema = z5.object({
  code: z5.nullable(code),
  title: z5.string(),
  type: z5.enum(["introduction", "location", "conclusion", "narrative"]),
  pages: z5.nullable(z5.array(page)),
  config: z5.nullable(storyPointConfigSchema),
  order: z5.number()
});
var storySettingsSchema = z5.object({
  showDirectionsButtonOnLocationPoints: z5.optional(z5.boolean()),
  showCodeEntry: z5.optional(z5.boolean()),
  /** The player's look for this story; missing means 'classic'. */
  playerTheme: z5.optional(playerTheme),
  /** How the story is presented; missing means 'map', the standard player. */
  // A string, not the `storyShell` enum: see phoneShell/schema.ts.
  shell: z5.optional(z5.string()),
  /** The pretend phone's set-up; ignored unless `shell` is 'phone'. */
  phone: z5.optional(phoneSettingsSchema)
});
var storySchema = z5.object({
  id: z5.string(),
  created_at: z5.string(),
  trail: z5.string(),
  code,
  title: z5.string(),
  storyPoints: z5.array(storyPointSchema),
  accessToken: z5.nullable(z5.string()),
  settings: z5.nullable(storySettingsSchema)
});
var trailConfigSchema = z5.nullable(
  z5.record(z5.string(), z5.union([z5.string(), z5.boolean(), z5.number()]))
);
var trailSchema = z5.object({
  id: z5.string(),
  Name: z5.string(),
  created_at: z5.string(),
  version: z5.number(),
  config: trailConfigSchema,
  stories: z5.record(z5.string(), storySchema),
  points: z5.array(trailPointSchema)
});
var reducedLocationPointSchema = z5.object({
  code,
  type: z5.literal("location"),
  lat: z5.number(),
  lng: z5.number(),
  title: z5.nullable(z5.string()),
  address: z5.nullable(z5.string()),
  locationImage: z5.nullable(z5.string())
});
var reducedStorySchema = z5.object({
  code,
  title: z5.string(),
  storyPoints: z5.array(storyPointSchema),
  accessToken: z5.nullable(z5.string()),
  config: z5.nullable(storySettingsSchema)
});
var trailAttributionSchema = z5.union([z5.literal("organisation"), z5.literal("magicalTrails")]).optional();
var reducedTrailSchema = z5.object({
  id: z5.string(),
  stories: z5.array(reducedStorySchema),
  version: z5.number(),
  points: z5.array(reducedLocationPointSchema),
  config: trailConfigSchema,
  // The running organisation's name (joined via the trail's orgId), so the
  // player can be told who actually runs the trail. Optional so a
  // CDN-cached payload captured before this field existed still parses —
  // the consent/attribution screen falls back to generic wording when absent.
  organisationName: z5.optional(z5.string()),
  attribution: trailAttributionSchema
});
var pointApiResponseSchema = z5.object({
  code,
  type: z5.union([
    z5.literal("location"),
    z5.literal("urlRedirect"),
    z5.literal("story")
  ]),
  accessToken: z5.nullable(z5.string()),
  trail: reducedTrailSchema
});
var trailVersionResponseSchema = z5.object({
  id: z5.string(),
  version: z5.number()
});
var storyPointStatusSchema = z5.enum([
  "untouched",
  "awaitingQuestionAnswer",
  "locked",
  "completed",
  "hidden",
  "geofenced"
]);
var baseHydratedStoryPoint = storyPointSchema.extend({
  code,
  currentPage: z5.optional(z5.number()),
  viewed: z5.optional(z5.boolean()),
  status: z5.optional(storyPointStatusSchema),
  // Phone shell, client only. `deliveredAt` is when the message landed (or
  // will land, while its delay runs); stamped once and never moved. `readAt`
  // is when the player first had its thread open.
  deliveredAt: z5.optional(z5.string()),
  readAt: z5.optional(z5.string()),
  // Set by reconcileStoryPoints when the author removed this stop from the
  // live trail AFTER the player completed it: it stays on their list as
  // done (with the content they saw), but a fresh start of the story won't
  // show it. Never set on a point the trail still contains.
  removedFromTrail: z5.optional(z5.boolean())
});
var hydratedLocationStoryPointSchema = baseHydratedStoryPoint.extend({
  type: z5.literal("location"),
  latlng: z5.tuple([z5.number(), z5.number()]),
  scanned: z5.optional(z5.string()),
  locationPoint: z5.optional(locationPointSchema)
});
var hydratedNarrativeStoryPointSchema = baseHydratedStoryPoint.extend({
  type: z5.enum(["introduction", "conclusion", "narrative"])
});
var hydratedStoryPointSchema = z5.union([
  hydratedLocationStoryPointSchema,
  hydratedNarrativeStoryPointSchema
]);
var hydratedStorySchema = z5.object({
  code,
  title: z5.string(),
  storyPoints: z5.array(hydratedStoryPointSchema),
  config: z5.nullable(storySettingsSchema),
  startedAt: z5.string(),
  trailSessionToken: z5.string(),
  version: z5.number()
});
var storyPointFullSchema = storyPointSchema.extend({
  created_at: z5.string(),
  id: z5.string()
});
var storyEditorSchema = z5.object({
  id: z5.string(),
  orgId: z5.string(),
  created_at: z5.string(),
  trail: z5.object({
    id: z5.string(),
    Name: z5.string(),
    config: z5.nullable(
      z5.record(z5.string(), z5.union([z5.string(), z5.boolean(), z5.number()]))
    ),
    points: z5.array(trailPointSchema),
    version: z5.number(),
    created_at: z5.string()
  }),
  code,
  title: z5.string(),
  accessToken: z5.nullable(z5.string()),
  config: z5.nullable(storySettingsSchema),
  description: z5.nullable(z5.string()),
  image: z5.nullable(z5.string()),
  storyPoints: z5.array(storyPointFullSchema)
});
var storyEditorResponseSchema = z5.array(storyEditorSchema);

// src/zodSchemas/nominatimLocationSchema.ts
import { z as z6 } from "zod";
var nominatimLocationSchema = z6.object({
  boundingbox: z6.tuple([z6.string(), z6.string(), z6.string(), z6.string()]),
  class: z6.string(),
  display_name: z6.string(),
  icon: z6.string(),
  importance: z6.number(),
  lat: z6.string(),
  licence: z6.string(),
  lon: z6.string(),
  osm_id: z6.number(),
  osm_type: z6.string(),
  place_id: z6.number(),
  type: z6.string()
});

// src/generateCode.ts
var CHARSET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
function generateCode(length = 8) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let value = "";
  for (let index = 0; index < length; index += 1) {
    value += CHARSET[bytes[index] % CHARSET.length];
  }
  return value;
}
var GENERATED_CODE = new RegExp(`^[${CHARSET}]{8}$`);
function isGeneratedCode(value) {
  return typeof value === "string" && GENERATED_CODE.test(value);
}

// src/pageCatalog/pageTypes.ts
var PAGE_TYPES = [
  {
    value: "pageLayout01",
    label: "Narrative",
    description: "Story content with text and images"
  },
  {
    value: "pageLayout02",
    label: "Article",
    description: "Long-form article layout"
  },
  {
    value: "pageReveal01",
    label: "Image Reveal",
    description: "Split object reveal with background"
  },
  {
    value: "crackerReveal",
    label: "Christmas Cracker",
    description: "Pull a shiny 3D cracker apart: it bangs, the screen flashes and the trail moves on to the next page"
  },
  {
    value: "question",
    label: "Question",
    description: "Interactive question for participants"
  },
  {
    value: "starburst",
    label: "Reveal",
    description: "Dramatic reveal with visual effects"
  },
  {
    value: "showcase3d",
    label: "3D Showcase",
    description: "A 3D object players can spin, with lighting and particle effects. Built-in candy cane, bauble, star or present, or upload a .glb model"
  },
  {
    value: "audioPage",
    label: "Audio Guide",
    description: "Article with a narrated audio player"
  },
  {
    value: "videoPage",
    label: "Video",
    description: "Full-screen short-style video"
  },
  {
    value: "selfie",
    label: "Magic Selfie",
    description: "Face AR selfie with fun lenses"
  },
  {
    value: "iframe",
    label: "Web Content",
    description: "Embed external web content"
  },
  {
    value: "locationCheck",
    label: "Location Check",
    description: "Require participants to be within a geofence"
  },
  {
    value: "qrCheck",
    label: "QR Checkpoint",
    description: "Prove arrival by scanning ANY existing QR code at the location"
  },
  {
    value: "arMarker",
    label: "AR Marker",
    description: "3D object anchored to a printed trail sign"
  },
  {
    value: "fairyEncounter",
    label: "Fairy Encounter",
    description: "Search the area (or a sign) with your camera to find a magical fairy"
  },
  {
    value: "signalDetector",
    label: "Signal Detector",
    description: "A Ghostbusters-style hunt: follow a themed detector's needle and signal strength to a hidden spot a couple of metres away. Camera on."
  },
  {
    value: "signReveal",
    label: "Sign Reveal",
    description: "Scan a real sign with a themed scanner and a 3D reveal appears attached to it: a glowing code plaque and/or an object."
  },
  {
    value: "spellCast",
    label: "Spell Cast",
    description: "Draw a shape in the air with a magic wand: a stream of glowing particles has to make a circle, triangle, square or star in one go. Camera on."
  },
  {
    value: "creaturePhoto",
    label: "Creature Photo",
    description: "Find a 3D character nearby, watch it run about and wave (or hover), and take a real photo with it. Fairy, fox, bunny, penguin, robot, dragon, ghost or owl. Camera on."
  },
  {
    value: "feedingGame",
    label: "Feed Me",
    description: "A giant floating pumpkin (or monster, snowman, frog, dragon) drifts nearby with its mouth open. Flick food into it: hits make it happy, misses make it sad. Camera on."
  },
  {
    value: "magicMirror",
    label: "Magic Mirror",
    description: "The front camera as a mirror, with ghosts, baubles or bubbles floating past for the player to pop with their hands. Optional letter tiles spell out a word or code. Camera on; falls back to tapping when the camera or hand tracking is unavailable."
  },
  {
    value: "arChomp",
    label: "Chomp",
    description: "Every face the camera can see gets a big cartoon mouth. Throw sweets, cookies or snowballs into them: a hit makes that mouth chomp, a miss makes it look sad. Camera on."
  },
  {
    value: "cauldronBrew",
    label: "Cauldron Brew",
    description: "A witch's cauldron on the ground and ingredients floating all around. Solve the riddle, tap an ingredient to pick it up and flick it into the pot. Wrong ones puff green smoke. Camera on."
  },
  {
    value: "towerToppleGame",
    label: "Haunted Tower",
    description: "Knock a tall tower of crates, pumpkins and ghosts off its plinth with a pumpkin catapult. Real physics: hit the bottom and the lot comes crashing down. Camera on."
  },
  // Games
  {
    value: "tapTheThingGame",
    label: "Tap Game",
    description: "Tap falling objects game"
  },
  {
    value: "slidingTilePuzzleGame",
    label: "Tile Puzzle",
    description: "Sliding tile puzzle game"
  },
  {
    value: "imageSliceMatcherGame",
    label: "Image Match",
    description: "Match image slices game"
  },
  {
    value: "decoderRingGame",
    label: "Decoder Ring",
    description: "Decode emoji messages"
  },
  {
    value: "visionMatch",
    label: "Vision Match",
    description: "Camera-based object recognition"
  },
  {
    value: "objectScan",
    label: "Object Scanner",
    description: "Point the camera at a real thing, a bench, a bike, a dog, and the page completes when the on-device detector sees it. Camera on."
  },
  {
    value: "snapChase",
    label: "Snap Chase",
    description: "AR chase with sprite character"
  },
  {
    value: "snapChaseAR",
    label: "Snap Chase AR",
    description: "The Snap Chase sprite character anchored in the real world: it flies above or runs around a spot ahead, and the shutter takes a real photo. Camera on."
  },
  {
    value: "arShooterGame",
    label: "AR Shooter",
    description: "Shoot pumpkins or pop balloons in AR"
  },
  {
    value: "sliceGame",
    label: "Slice Game",
    description: "Swipe to slice flying objects (Fruit-Ninja style)"
  },
  {
    value: "whackGame",
    label: "Whack Game",
    description: "Tap pop-up characters (whack-a-mole style)"
  },
  {
    value: "targetTossGame",
    label: "Target Toss Game",
    description: "Flick a projectile in an arc to hit a target"
  },
  {
    value: "stackGame",
    label: "Stack Game",
    description: "Time your taps to stack a tower of blocks"
  },
  {
    value: "spinWheelGame",
    label: "Spin Wheel Game",
    description: "Flick a segmented wheel to rack up points"
  },
  {
    value: "basketCatchGame",
    label: "Basket Catch Game",
    description: "Catch falling items in a moving basket (drag or tilt)"
  },
  {
    value: "memoryPairsGame",
    label: "Memory Pairs Game",
    description: "Quiet flip-card matching game (museum-friendly)"
  },
  {
    value: "tiltMazeGame",
    label: "Tilt Maze Game",
    description: "Tilt to roll a ball through a maze to the goal"
  },
  // Presets: create an existing game type pre-themed. The synthetic value is
  // only used at creation time; the resulting page has a real page `type`.
  {
    value: "tapTheThingGameFestive",
    label: "Festive Tap Game (preset)",
    description: "Tap the dropping Christmas presents \u2014 a wintry Tap Game"
  },
  {
    value: "luminaGame",
    label: "Lumina Grove",
    description: "Circle a decorated egg, bauble or orb with a finger to weave the magic, then crack it open (optionally revealing an image)"
  },
  {
    value: "melodyGame",
    label: "Melody Game",
    description: "Play back a melody on strings, piano, drums or chimes to proceed"
  },
  {
    value: "numberLock",
    label: "Number Lock",
    description: "Find a number nearby (a year on a plaque, a sign\u2026) and enter it on a keypad, briefcase, padlock, safe or treasure chest to proceed"
  },
  {
    value: "cipherLock",
    label: "Cipher Lock",
    description: "Find the key nearby, turn a Caesar cipher wheel to it and decode the hidden message to proceed"
  },
  {
    value: "treasureChest",
    label: "Treasure Chest",
    description: "Find a chest in AR, walk up to it, then open its combination padlock with a code found on the trail."
  },
  {
    value: "nfcTap",
    label: "NFC Tap",
    description: "Blocks the trail until the visitor holds their phone against an NFC tag on a poster or sign"
  }
];
function basePageType(value) {
  switch (value) {
    case "tapTheThingGameFestive":
      return "tapTheThingGame";
    default:
      return value;
  }
}

// src/pageCatalog/defaultPages.ts
function svgPlaceholder(emoji, label, bg = "#4c6ef5", width = 200, height = 200) {
  const emojiSize = Math.round(Math.min(width, height) * 0.42);
  const labelSize = Math.max(12, Math.round(Math.min(width, height) * 0.1));
  const radius = Math.round(Math.min(width, height) * 0.12);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"><rect width="${width}" height="${height}" rx="${radius}" fill="${bg}"/><text x="50%" y="${Math.round(height * 0.5)}" font-size="${emojiSize}" text-anchor="middle" dominant-baseline="central">${emoji}</text><text x="50%" y="${Math.round(height * 0.88)}" font-size="${labelSize}" text-anchor="middle" fill="#ffffff" font-family="sans-serif">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
function svgSpriteSheet(emoji, frames = 8, frame = 64) {
  const cells = Array.from({ length: frames }, (_, i) => {
    const cx = i * frame + frame / 2;
    const cy = frame / 2;
    const angle = Math.round(Math.sin(i / frames * Math.PI * 2) * 14);
    return `<text x="${cx}" y="${cy}" font-size="${Math.round(frame * 0.7)}" text-anchor="middle" dominant-baseline="central" transform="rotate(${angle} ${cx} ${cy})">${emoji}</text>`;
  }).join("");
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${frames * frame}" height="${frame}">` + cells + `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
var PAGE_REVEAL_PLACEHOLDER = {
  backgroundImage: svgPlaceholder("\u{1F332}", "Background", "#2b5f3f", 800, 600),
  objectImage: svgPlaceholder("\u2728", "Object", "#5f3dc4", 400, 400),
  revealedImage: svgPlaceholder("\u{1F389}", "Revealed", "#e8590c", 400, 400)
};
var LOCATION_CHECK_DEFAULT_RADIUS = 25;
var SNAP_CHASE_PLACEHOLDER = {
  panoImageUrl: svgPlaceholder("\u{1F3DE}\uFE0F", "Panorama", "#1864ab", 1200, 600),
  character: {
    imageUrl: svgSpriteSheet("\u{1F98B}", 8, 64),
    frames: 8,
    fps: 12,
    frameSize: [64, 64]
  },
  distance: 3,
  size: 1.5,
  characterMovementY: 0.5,
  characterSpeed: 1,
  spawnInFront: true
};
function createDefaultPage(type) {
  const baseDefaults = {
    title: "New Page"
  };
  switch (type) {
    case "pageLayout01":
      return {
        type: "pageLayout01",
        ...baseDefaults,
        image: svgPlaceholder("\u{1F5BC}\uFE0F", "Add Your Image", "#495057", 400, 300),
        content: "<p>Enter your story content here...</p>",
        allowNavigation: true,
        particles: void 0,
        showCloseButton: false
      };
    case "pageLayout02":
      return {
        type: "pageLayout02",
        ...baseDefaults,
        content: "<p>Enter your story content here...</p>",
        allowNavigation: true,
        showCloseButton: false
      };
    case "pageReveal01":
      return {
        type: "pageReveal01",
        ...baseDefaults,
        ...PAGE_REVEAL_PLACEHOLDER
      };
    case "question":
      return {
        type: "question",
        ...baseDefaults,
        question: "What is your question?",
        answerType: "text",
        answer: ""
      };
    case "starburst":
      return {
        type: "starburst",
        ...baseDefaults,
        image: svgPlaceholder("\u{1F5BC}\uFE0F", "Add Your Image", "#495057", 400, 300),
        allowNavigation: true
      };
    case "showcase3d":
      return {
        type: "showcase3d",
        title: "You found it!",
        model: "candyCane",
        environment: "festive",
        particles: "sparkles",
        autoRotate: true,
        allowNavigation: true
      };
    case "crackerReveal":
      return {
        type: "crackerReveal",
        title: "A Christmas cracker!",
        instructions: "Pull the cracker!"
      };
    case "audioPage":
      return {
        type: "audioPage",
        ...baseDefaults,
        content: "<p>Describe this stop on the tour...</p>",
        audioUrl: "",
        autoplay: false,
        allowNavigation: true,
        showCloseButton: false
      };
    case "videoPage":
      return {
        type: "videoPage",
        ...baseDefaults,
        videoUrl: "",
        autoAdvance: false,
        loop: true,
        startMuted: true,
        allowNavigation: true
      };
    case "selfie":
      return {
        type: "selfie",
        title: "Magic Selfie",
        lenses: [...DEFAULT_SELFIE_LENSES],
        defaultLens: "starGlasses"
      };
    case "arShooterGame":
      return {
        type: "arShooterGame",
        title: "Pumpkin Shooter",
        variant: "pumpkins",
        targetScore: 8,
        instructions: "Tap to shoot the pumpkins!",
        fallbackMode: false
      };
    case "luminaGame":
      return {
        type: "luminaGame",
        title: "Lumina, the Firefly Grove",
        theme: "fireflies",
        target: "orb",
        moteCount: 200,
        instructions: "<p>Drag your finger through the grove to gather the fireflies. Hold the swarm over the magic orb in the centre and keep it there \u2014 the magic charges until it comes fully to life.</p>",
        completeTitle: "The grove is alight",
        completeText: "<p>The magic orb blazes with light. Beautifully done.</p>"
      };
    case "iframe":
      return {
        type: "iframe",
        ...baseDefaults,
        iframeUrl: "https://example.com",
        allowNavigation: true
      };
    // Games with base game structure
    case "tapTheThingGame":
      return {
        type: "tapTheThingGame",
        ...baseDefaults,
        images: [svgPlaceholder("\u2B50", "Game Object", "#f08c00", 100, 100)],
        targetScore: 10,
        movementStyle: "falling",
        instructions: "Tap the falling objects to score points!"
      };
    case "slidingTilePuzzleGame":
      return {
        type: "slidingTilePuzzleGame",
        ...baseDefaults,
        image: svgPlaceholder("\u{1F9E9}", "Puzzle Image", "#5f3dc4", 300, 300),
        difficulty: "easy",
        instructions: "Slide the tiles to complete the puzzle!"
      };
    case "imageSliceMatcherGame":
      return {
        type: "imageSliceMatcherGame",
        ...baseDefaults,
        images: [
          svgPlaceholder("\u{1F98A}", "Image 1", "#e8590c"),
          svgPlaceholder("\u{1F989}", "Image 2", "#1864ab")
        ],
        correctIndex: 0,
        sections: [2, 2],
        instructions: "Match the image slices!"
      };
    case "decoderRingGame":
      return {
        type: "decoderRingGame",
        ...baseDefaults,
        message: "HELLO",
        emojiSet: "default",
        instructions: "Decode the emoji message!"
      };
    case "visionMatch":
      return {
        type: "visionMatch",
        ...baseDefaults,
        visionMatchImages: [svgPlaceholder("\u{1F50D}", "Target Object", "#2b8a3e")],
        matchThreshold: 15,
        instructions: "Point your camera at the object to continue!"
      };
    case "objectScan":
      return {
        type: "objectScan",
        ...baseDefaults,
        targetObject: "bench",
        confidence: 0.5,
        holdSeconds: 1,
        instructions: "<p>Find a bench and point your camera at it. Keep the whole bench in the picture and hold still for a moment.</p>",
        completeTitle: "Found it!"
      };
    case "sliceGame":
      return {
        type: "sliceGame",
        ...baseDefaults,
        images: [
          svgPlaceholder("\u{1F34E}", "Fruit 1", "#c92a2a", 160, 160),
          svgPlaceholder("\u{1F349}", "Fruit 2", "#2b8a3e", 160, 160)
        ],
        bombImages: [svgPlaceholder("\u{1F4A3}", "Bomb", "#212529", 160, 160)],
        targetScore: 12,
        spawnIntervalMs: 850,
        objectSpeed: 1,
        gravity: 4.5,
        maxOnScreen: 5,
        instructions: "Swipe across the flying objects to slice them!",
        completeTitle: "Nicely sliced!",
        wrongAnswerTitle: "Boom! That was a bomb."
      };
    case "whackGame":
      return {
        type: "whackGame",
        ...baseDefaults,
        images: [
          svgPlaceholder("\u{1F439}", "Character 1", "#a05a2c", 160, 200),
          svgPlaceholder("\u{1F430}", "Character 2", "#5f3dc4", 160, 200)
        ],
        decoyImages: [svgPlaceholder("\u{1F4A3}", "Decoy", "#212529", 160, 200)],
        targetScore: 15,
        holeCount: 9,
        popDurationMs: 1100,
        spawnIntervalMs: 750,
        instructions: "Tap the characters as they pop up from their holes!",
        completeTitle: "Great whacking!"
      };
    case "targetTossGame":
      return {
        type: "targetTossGame",
        ...baseDefaults,
        targetImages: [svgPlaceholder("\u{1F3AF}", "Target", "#c92a2a", 160, 160)],
        projectileImage: svgPlaceholder("\u26BE", "Ball", "#1864ab", 120, 120),
        targetScore: 5,
        movingTarget: true,
        throws: 10,
        instructions: "Drag and release to flick the ball at the target!",
        completeTitle: "Bullseye!",
        wrongAnswerTitle: "Out of throws!"
      };
    case "stackGame":
      return {
        type: "stackGame",
        ...baseDefaults,
        blockImage: "",
        blockColor: "#33aaff",
        targetScore: 10,
        speed: 2.4,
        instructions: "Tap to drop each block and build the tallest tower!",
        completeTitle: "Tower complete!",
        wrongAnswerTitle: "Missed the tower!"
      };
    case "spinWheelGame":
      return {
        type: "spinWheelGame",
        ...baseDefaults,
        segments: [
          { label: "Jackpot", value: 50, color: "#ef476f" },
          { label: "Prize", value: 20, color: "#ffd166" },
          { label: "Bonus", value: 30, color: "#06d6a0" },
          { label: "Small", value: 10, color: "#118ab2" }
        ],
        targetScore: 100,
        instructions: "Flick the wheel to spin and rack up points!",
        completeTitle: "You hit the target!"
      };
    // Festive preset for the existing Tap Game: dropping Christmas presents
    // with a wintry particle burst and snowy copy. Not a new mechanic — just
    // themeable defaults on tapTheThingGame.
    case "tapTheThingGameFestive":
      return {
        type: "tapTheThingGame",
        title: "Catch the Presents",
        images: [
          svgPlaceholder("\u{1F381}", "Present", "#c92a2a", 100, 100),
          svgPlaceholder("\u{1F384}", "Gift", "#2b8a3e", 100, 100)
        ],
        targetScore: 12,
        movementStyle: "falling",
        particleColor: "custom",
        customParticleColors: ["#ffffff", "#bcdcff", "#8ecae6", "#e0f7ff"],
        instructions: "Tap the presents as they drop through the snow! \u2744\uFE0F\u{1F381}",
        completeTitle: "Ho ho ho \u2014 you caught them all! \u{1F385}"
      };
    case "basketCatchGame":
      return {
        type: "basketCatchGame",
        ...baseDefaults,
        itemImages: [
          svgPlaceholder("\u{1F34E}", "Item 1", "#c92a2a", 120, 120),
          svgPlaceholder("\u{1F350}", "Item 2", "#2b8a3e", 120, 120)
        ],
        basketImage: svgPlaceholder("\u{1F9FA}", "Basket", "#a05a2c", 160, 120),
        targetScore: 12,
        lives: 3,
        useTilt: false,
        fallSpeed: 0.9,
        spawnIntervalMs: 950,
        instructions: "Move the basket to catch the falling items!",
        completeTitle: "Great catching!",
        wrongAnswerTitle: "Out of lives!"
      };
    case "memoryPairsGame":
      return {
        type: "memoryPairsGame",
        ...baseDefaults,
        images: [
          svgPlaceholder("\u{1F98A}", "Card 1", "#e8590c"),
          svgPlaceholder("\u{1F989}", "Card 2", "#1864ab"),
          svgPlaceholder("\u{1F43F}\uFE0F", "Card 3", "#a05a2c"),
          svgPlaceholder("\u{1F344}", "Card 4", "#c92a2a")
        ],
        instructions: "Flip two cards at a time to find the matching pairs!",
        completeTitle: "All pairs matched!"
      };
    case "tiltMazeGame":
      return {
        type: "tiltMazeGame",
        ...baseDefaults,
        ballImage: "",
        mazeSize: 6,
        wallColor: "#4c6ef5",
        instructions: "Tilt your phone to roll the ball to the green goal pad!",
        completeTitle: "You reached the goal!",
        wrongAnswerTitle: "Out of time!"
      };
    case "locationCheck":
      return {
        type: "locationCheck",
        ...baseDefaults,
        geofenceRadius: LOCATION_CHECK_DEFAULT_RADIUS,
        content: "<p>Head towards the target location and we will confirm when you arrive.</p>"
      };
    case "qrCheck":
      return {
        type: "qrCheck",
        title: "Scan the code",
        instructions: "<p>Find the QR code at this stop and point your camera at it to check in.</p>",
        expectedValue: "https://example.com/poster",
        matchMode: "exact",
        caseSensitive: false,
        completeTitle: "You're in the right place!",
        completeText: "<p>Nicely done \u2014 you found it.</p>",
        wrongScanTitle: "That's not the right code \u2014 keep looking!"
      };
    case "melodyGame":
      return {
        type: "melodyGame",
        title: "Play the melody",
        instrument: "chimes",
        sequence: [0, 2, 4, 1],
        allowFreePlay: true,
        instructions: "<p>Listen to the melody, then play it back on the chimes to open the way. Miss a couple of times and the next note will light up to guide you.</p>",
        completeTitle: "Perfectly played!",
        completeText: "<p>The melody rings true \u2014 the way is open.</p>"
      };
    case "numberLock":
      return {
        type: "numberLock",
        title: "Find the year",
        code: "1874",
        lockStyle: "keypad",
        instructions: "<p>Look for the foundation stone beside the main door. The year it was laid is the code.</p>",
        lockPrompt: "Enter the year",
        hint: "<p>Look low on the wall, to the left of the door.</p>",
        hintAfterAttempts: 3,
        allowSkip: true,
        completeTitle: "Unlocked!",
        completeText: "<p>The lock gives way \u2014 on you go.</p>"
      };
    case "cipherLock":
      return {
        type: "cipherLock",
        title: "Crack the code",
        answer: "WELL HOUSE",
        shift: 7,
        instructions: "<p>The key is the number of steps up to the chapel door. Count them, then turn the wheel to that number and read the message.</p>",
        lockPrompt: "Turn the wheel to the key",
        hint: "<p>Count only the stone steps, not the threshold.</p>",
        hintAfterAttempts: 3,
        allowSkip: true,
        completeTitle: "Decoded!",
        completeText: "<p>The message is clear \u2014 on you go.</p>"
      };
    case "arMarker":
      return {
        type: "arMarker",
        title: "Find the trail sign",
        instructions: "<p>Point your camera at the Magical Trails sign to reveal a hidden surprise.</p>",
        object: "chest",
        markerSizeMm: 150,
        mount: "auto",
        completeTitle: "You found it!",
        completeText: "<p>Nicely done \u2014 you found the hidden object.</p>"
      };
    case "fairyEncounter":
      return {
        type: "fairyEncounter",
        title: "Find the fairy",
        instructions: "<p>A fairy is hiding somewhere near you! Move your phone slowly to search for her.</p>",
        appearance: { element: "nature" },
        anchor: "area",
        placement: "auto",
        completeTitle: "You found her!",
        completeText: "<p>The fairy waves goodbye and darts away in a swirl of sparkles\u2026</p>"
      };
    case "signalDetector":
      return {
        type: "signalDetector",
        title: "Follow the signal",
        instructions: "<p>Something magical is hiding close by. Sweep your phone around to warm the detector up, then follow the needle until the signal maxes out.</p>",
        theme: "classic",
        signalName: "the signal",
        hideDistanceM: 2,
        foundRadiusM: 0.6,
        completeTitle: "You found it!",
        completeText: "<p>The detector goes wild. Whatever was hiding here has just been found.</p>"
      };
    case "spellCast":
      return {
        type: "spellCast",
        title: "Cast the spell",
        instructions: "<p>Hold your finger on the screen and move your phone to draw the shape in the air. Draw it in one go, and finish where you started!</p>",
        shape: "circle",
        wand: "wand",
        theme: "classic",
        spellName: "the spell",
        showGuide: true,
        completeTitle: "The spell is cast!",
        completeText: "<p>The shape blazes with light, and the magic is loose.</p>"
      };
    case "signReveal":
      return {
        type: "signReveal",
        title: "Scan the sign",
        instructions: "<p>Find the sign, then hold your camera up to it and wait for the scanner to lock on.</p>",
        theme: "classic",
        targetKind: "printedFrame",
        markerSizeMm: 150,
        revealObject: "pumpkin",
        dwellSeconds: 4,
        completeTitle: "There it is!",
        completeText: "<p>The sign glows, and the hidden thing shows itself at last.</p>"
      };
    case "treasureChest":
      return {
        type: "treasureChest",
        title: "Find the buried chest",
        instructions: "<p>A chest is hidden somewhere close by. Sweep your phone around to find it, walk up to it, then open the padlock with the number you found on the trail.</p>",
        chestName: "the treasure chest",
        hideDistanceM: 2.2,
        openRadiusM: 1,
        // A working placeholder (like numberLock's) so a fresh page previews
        // and saves; authors replace it with the number found on the trail.
        code: "1031",
        lockPrompt: "Enter the number you found",
        hint: "<p>Look low on the wall, to the left of the door.</p>",
        hintAfterAttempts: 3,
        allowSkip: true,
        completeTitle: "The chest creaks open!",
        completeText: "<p>The padlock drops into the grass and the lid swings back.</p>"
      };
    case "snapChaseAR":
      return {
        type: "snapChaseAR",
        title: "Snap the dragon",
        instructions: "<p>A dragon is flying nearby! Look around to find it, line it up on screen and press the shutter to take a photo.</p>",
        character: SNAP_CHASE_PLACEHOLDER.character,
        characterSizeM: 0.9,
        locomotion: "fly",
        flyHeightM: 1.3,
        passVisibleRatio: 0.3,
        completeTitle: "Great shot!",
        completeText: "<p>You caught it on camera. Off it flies\u2026</p>"
      };
    case "creaturePhoto":
      return {
        type: "creaturePhoto",
        title: "Say hello",
        instructions: "<p>Someone is waiting to meet you. Move your phone around slowly to find them, then take a photo together!</p>",
        creature: "fox",
        completeTitle: "What a photo!",
        completeText: "<p>Your new friend waves goodbye and scampers off.</p>"
      };
    case "feedingGame":
      return {
        type: "feedingGame",
        title: "Feed the pumpkin",
        instructions: "<p>A very hungry pumpkin is floating nearby. Flick sweets up into its mouth. It moves about, and it will not let you get too close, but it really wants feeding!</p>",
        creature: "pumpkin",
        targetFeeds: 6,
        completeTitle: "Full at last!",
        completeText: "<p>The pumpkin burps happily and drifts away.</p>"
      };
    case "arChomp":
      return {
        type: "arChomp",
        mouthStyle: "mixed",
        title: "Chomp!",
        instructions: "<p>Point the camera at your friends and everyone gets a big cartoon mouth. Flick sweets into them as fast as you can. A hit and the mouth chomps, a miss and it looks very sad indeed!</p>",
        food: "candy",
        targetFeeds: 8,
        completeTitle: "All fed!",
        completeText: "<p>Every mouth is full and grinning. Off you go to the next stop.</p>"
      };
    case "cauldronBrew":
      return {
        type: "cauldronBrew",
        title: "Brew the potion",
        instructions: "<p>The witch has left her cauldron bubbling, and the ingredients are floating all around you. Read the riddle, tap an ingredient to pick it up, then flick it into the pot. Get the recipe right and the brew is done!</p>",
        recipe: ["eyeball", "toadstool", "batWing"],
        decoys: ["frog", "bone", "sweet", "spider"],
        riddle: "First the thing that sees in the dark. Then the red cap that grows in the woods. Last, a wing that flaps at midnight.",
        orderMatters: true,
        completeTitle: "The brew is done!",
        completeText: "<p>The cauldron flashes purple and a plume of stars rises out of it.</p>"
      };
    case "towerToppleGame":
      return {
        type: "towerToppleGame",
        title: "The haunted tower",
        instructions: "<p>A tall tower of crates, pumpkins and ghosts is standing on a plinth ahead. Flick pumpkins at it from your catapult and knock every last piece off. Aim low: hit the bottom and the whole lot comes crashing down.</p>",
        blocks: "mixed",
        rows: 8,
        shots: 10,
        completeTitle: "Timber!",
        completeText: "<p>The tower is rubble and the ghosts have fled. On you go.</p>"
      };
    case "magicMirror":
      return {
        type: "magicMirror",
        title: "The magic mirror",
        instructions: "<p>Hold your phone up like a mirror and stand back a little, so your hands are in the picture. Friendly ghosts will float past. Reach out and pop them!</p>",
        theme: "halloween",
        goal: "popAll",
        targetCount: 10,
        // No face lens by default: the mirror is about the things floating
        // in it, and a hat is an opt-in extra an author chooses.
        completeTitle: "The mirror is clear!",
        completeText: "<p>Every last ghost popped. The mirror settles, and something new appears in the glass.</p>"
      };
    case "nfcTap":
      return {
        type: "nfcTap",
        title: "Touch the sigil",
        // A fresh secret per page: two NFC Tap pages on one trail must never
        // open each other.
        token: generateNfcToken(),
        instructions: "<p>Press your phone flat against the glowing mark on the poster and hold it still.</p>",
        scanPrompt: "Hold your phone against the mark",
        allowSkip: false,
        completeTitle: "The mark answers",
        completeText: "<p>A warm glow spreads under your fingers. On you go.</p>"
      };
    case "snapChase":
      return {
        type: "snapChase",
        ...baseDefaults,
        instructions: "<p>Move your camera around to find the character and snap the photo!</p>",
        instructionsImage: svgPlaceholder(
          "\u{1F4F8}",
          "Instructions",
          "#1864ab",
          400,
          300
        ),
        ...SNAP_CHASE_PLACEHOLDER,
        character: SNAP_CHASE_PLACEHOLDER.character,
        completeTitle: "Great shot!",
        wrongAnswerTitle: "Try again"
      };
    default:
      return createDefaultPage("pageLayout01");
  }
}

// src/pointResolution/fetchTrailPoint.ts
async function fetchTrailPoint(code2, { baseUrl, path = "/api/point", version }) {
  try {
    const url = new URL(path, baseUrl);
    url.searchParams.set("code", code2);
    if (typeof version === "number" && Number.isFinite(version)) {
      url.searchParams.set("v", String(version));
    }
    const response = await fetch(url);
    if (response.status === 404) {
      return { ok: false, reason: "notFound" };
    }
    if (!response.ok) {
      return { ok: false, reason: "network" };
    }
    let json;
    try {
      json = await response.json();
    } catch (error) {
      if (error instanceof SyntaxError) {
        return { ok: false, reason: "invalid", error };
      }
      throw error;
    }
    const validation = pointApiResponseSchema.safeParse(json);
    if (!validation.success) {
      return { ok: false, reason: "invalid", error: validation.error };
    }
    return { ok: true, data: validation.data };
  } catch (error) {
    return { ok: false, reason: "network", error };
  }
}

// src/pointResolution/fetchTrailVersion.ts
async function fetchTrailVersion(code2, { baseUrl, path = "/api/trail-version" }) {
  try {
    const url = new URL(path, baseUrl);
    url.searchParams.set("code", code2);
    const response = await fetch(url);
    if (response.status === 404) {
      return { ok: false, reason: "notFound" };
    }
    if (!response.ok) {
      return { ok: false, reason: "network" };
    }
    let json;
    try {
      json = await response.json();
    } catch (error) {
      if (error instanceof SyntaxError) {
        return { ok: false, reason: "invalid", error };
      }
      throw error;
    }
    const validation = trailVersionResponseSchema.safeParse(json);
    if (!validation.success) {
      return { ok: false, reason: "invalid", error: validation.error };
    }
    return { ok: true, data: validation.data };
  } catch (error) {
    return { ok: false, reason: "network", error };
  }
}

// src/pointResolution/resolutionHelpers.ts
function getStoriesUsingCode(trail, code2) {
  return trail.stories.filter(
    (story) => story.storyPoints.some((point) => point.code === code2)
  );
}
function cachedTrailIsStale(cachedVersion, fetchedVersion) {
  return typeof cachedVersion === "number" && typeof fetchedVersion === "number" && cachedVersion !== fetchedVersion;
}

// src/cipher.ts
var A = "A".charCodeAt(0);
var CIPHER_ALPHABET_SIZE = 26;
function normalizeCipherAnswer(text) {
  return text.toUpperCase().replace(/[^A-Z]/g, "");
}
function normalizeShift(shift) {
  const n = Math.round(shift) % CIPHER_ALPHABET_SIZE;
  return n < 0 ? n + CIPHER_ALPHABET_SIZE : n;
}
function shiftChar(ch, by) {
  const code2 = ch.charCodeAt(0);
  if (code2 < A || code2 > A + 25) return ch;
  return String.fromCharCode(A + (code2 - A + by) % CIPHER_ALPHABET_SIZE);
}
function caesarEncode(plain, shift) {
  const by = normalizeShift(shift);
  return plain.toUpperCase().split("").map((c) => shiftChar(c, by)).join("");
}
function caesarDecode(cipher, shift) {
  return caesarEncode(cipher, CIPHER_ALPHABET_SIZE - normalizeShift(shift));
}
function cipherLockCiphertext(answer, shift) {
  return caesarEncode(answer.trim().toUpperCase().replace(/\s+/g, " "), shift);
}
function decodesToAnswer(answer, authoredShift, shift) {
  const cipher = cipherLockCiphertext(answer, authoredShift);
  return normalizeCipherAnswer(caesarDecode(cipher, shift)) === normalizeCipherAnswer(answer);
}

// src/phoneShell/threads.ts
function defaultAppLabel(id, spec) {
  switch (id) {
    case "messages":
      return spec.messengerName;
    case "map":
      return spec.mapName;
    case "scanner":
      return spec.scannerName;
    case "codeEntry":
      return "Enter code";
  }
}
function resolvePhoneShell(settings) {
  if (settings?.shell !== "phone") return null;
  const phone = settings.phone ?? {};
  const themeSpec = phoneThemeSpec(phone.theme);
  const defaultIds = ["messages", "map", "scanner"];
  if (settings.showCodeEntry) defaultIds.push("codeEntry");
  const seen = /* @__PURE__ */ new Set();
  const listed = [];
  for (const app of phone.apps ?? []) {
    if (!isPhoneAppId(app.id) || seen.has(app.id)) continue;
    seen.add(app.id);
    listed.push({
      id: app.id,
      label: app.label?.trim() || defaultAppLabel(app.id, themeSpec)
    });
  }
  const apps = listed.length > 0 ? listed : defaultIds.map((id) => ({ id, label: defaultAppLabel(id, themeSpec) }));
  return {
    layout: phone.layout === "dock" ? "dock" : "home",
    theme: themeSpec.value,
    themeSpec,
    colours: phone.colours ?? {},
    apps,
    senders: phone.senders ?? {},
    threads: phone.threads ?? {}
  };
}
function messageDeliveryFor(point, settings) {
  if (settings?.shell !== "phone") return void 0;
  if (point.type === "location") return void 0;
  const delivery = point.config?.delivery;
  if (!delivery || delivery.channel !== "message") return void 0;
  return delivery;
}
function isUnlocked(point) {
  return point.status !== "hidden" && point.status !== "locked";
}
function dueDeliveries(points, settings, now) {
  const due = [];
  for (const point of points) {
    const delivery = messageDeliveryFor(point, settings);
    if (!delivery || point.deliveredAt || !isUnlocked(point)) continue;
    const delayMs = Math.max(0, delivery.delaySeconds ?? 0) * 1e3;
    due.push({
      code: point.code,
      deliveredAt: new Date(now + delayMs).toISOString()
    });
  }
  return due;
}
function bubbleKindFor(page2) {
  switch (page2.type) {
    case "pageLayout01":
    case "pageLayout02":
      return "text";
    case "audioPage":
      return "audio";
    case "videoPage":
      return "video";
    case "question":
      return "reply";
    case "visionMatch":
    case "objectScan":
      return "photoReply";
    default:
      return "card";
  }
}
function bubbleWaitsForPlayer(kind) {
  return kind === "reply" || kind === "photoReply" || kind === "card";
}
function own(record, key) {
  return Object.prototype.hasOwnProperty.call(record, key) ? record[key] : void 0;
}
function resolveSender(key, senders) {
  return own(senders, key) ?? { name: key };
}
function threadKeyFor(delivery, threads) {
  return delivery.thread && own(threads, delivery.thread) ? `group:${delivery.thread}` : `dm:${delivery.sender}`;
}
function messageCursor(point) {
  const pageCount = point.pages?.length ?? 0;
  if (point.status === "completed") return pageCount;
  return Math.min(Math.max(point.currentPage ?? 0, 0), pageCount);
}
function buildThreads(points, settings, now) {
  const shell = resolvePhoneShell(settings);
  if (!shell) return [];
  const byKey = /* @__PURE__ */ new Map();
  const typingAt = /* @__PURE__ */ new Map();
  for (const point of points) {
    const delivery = messageDeliveryFor(point, settings);
    if (!delivery || !point.deliveredAt || !isUnlocked(point)) continue;
    const deliveredAt = Date.parse(point.deliveredAt);
    if (Number.isNaN(deliveredAt)) continue;
    if ((point.pages?.length ?? 0) === 0) continue;
    const key = threadKeyFor(delivery, shell.threads);
    const sender = resolveSender(delivery.sender, shell.senders);
    let thread = byKey.get(key);
    if (!thread) {
      const group2 = key.startsWith("group:") ? own(shell.threads, delivery.thread) : void 0;
      thread = {
        key,
        name: group2?.name ?? sender.name,
        avatar: group2 ? group2.avatar : sender.avatar,
        role: group2 ? void 0 : sender.role,
        isGroup: Boolean(group2),
        messages: [],
        typing: null,
        unreadCount: 0,
        waitingOnPlayer: false,
        lastActivity: 0
      };
      byKey.set(key, thread);
    }
    if (deliveredAt > now) {
      const soonest = typingAt.get(key);
      if (soonest === void 0 || deliveredAt < soonest) {
        typingAt.set(key, deliveredAt);
        thread.typing = sender;
      }
      continue;
    }
    const pages = point.pages ?? [];
    const cursor = delivery.presentation === "attachment" ? point.status === "completed" ? pages.length : 0 : messageCursor(point);
    const done = point.status === "completed";
    const livePage = pages[cursor];
    const waitingOnPlayer = !done && (delivery.presentation === "attachment" || livePage !== void 0 && bubbleWaitsForPlayer(bubbleKindFor(livePage)));
    const message = {
      point,
      delivery,
      senderKey: delivery.sender,
      sender,
      state: done ? "done" : "active",
      deliveredAt,
      // Text is only typed out while the thread is open. A player who left
      // part-way has more to read, and whatever waits on this message stays
      // locked until they do, so it goes on counting as unread.
      unread: !point.readAt || !done && !waitingOnPlayer,
      cursor,
      waitingOnPlayer
    };
    thread.messages.push(message);
    if (message.unread) thread.unreadCount += 1;
    if (waitingOnPlayer) thread.waitingOnPlayer = true;
    thread.lastActivity = Math.max(thread.lastActivity, deliveredAt);
  }
  const threads = [];
  for (const thread of byKey.values()) {
    if (thread.messages.length === 0) continue;
    thread.messages.sort((a, b) => a.deliveredAt - b.deliveredAt);
    threads.push(thread);
  }
  return threads.sort((a, b) => b.lastActivity - a.lastActivity);
}
function nextDeliveryAt(points, settings, now) {
  let soonest = null;
  for (const point of points) {
    if (!point.deliveredAt || !messageDeliveryFor(point, settings)) continue;
    const at = Date.parse(point.deliveredAt);
    if (Number.isNaN(at) || at <= now) continue;
    if (soonest === null || at < soonest) soonest = at;
  }
  return soonest;
}
function totalUnread(threads) {
  return threads.reduce((sum, thread) => sum + thread.unreadCount, 0);
}

// src/pointResolution/reconcileProgress.ts
function samePageStructure(fresh, saved) {
  if (fresh.length !== saved.length) return false;
  return fresh.every((page2, index) => page2.type === saved[index]?.type);
}
var isLockGate = (page2) => page2.type === "numberLock" || page2.type === "treasureChest" || page2.type === "cipherLock" || page2.type === "nfcTap";
var lockExpectedAnswer = (page2) => {
  if (page2.type === "cipherLock") return normalizeCipherAnswer(page2.answer);
  if (page2.type === "nfcTap") return normalizeNfcToken(page2.token);
  return page2.code;
};
function carryAnswer(freshPage, savedPage) {
  if (!savedPage || savedPage.type !== freshPage.type) return freshPage;
  if (freshPage.type === "question" && savedPage.type === "question" && savedPage.userAnswer !== void 0 && savedPage.answer === freshPage.answer) {
    return { ...freshPage, userAnswer: savedPage.userAnswer };
  }
  if (isLockGate(freshPage) && isLockGate(savedPage)) {
    const saved = savedPage.userAnswer;
    const stillCounts = saved === lockExpectedAnswer(freshPage) || saved === NUMBER_LOCK_SKIPPED_ANSWER && freshPage.allowSkip !== false;
    if (stillCounts) return { ...freshPage, userAnswer: saved };
  }
  return freshPage;
}
function samePrefix(fresh, saved, cursor) {
  if (fresh.length === 0 || cursor <= 0) return false;
  for (let index = 0; index < cursor; index += 1) {
    if (!fresh[index] || fresh[index].type !== saved[index]?.type) return false;
  }
  return true;
}
function mergePoint(fresh, saved, settings) {
  const completed = saved.status === "completed";
  const merged = {
    ...fresh,
    viewed: saved.viewed ?? fresh.viewed
  };
  if (completed) merged.status = "completed";
  if (saved.deliveredAt) merged.deliveredAt = saved.deliveredAt;
  if (saved.readAt) merged.readAt = saved.readAt;
  if (merged.type === "location" && saved.type === "location" && saved.scanned) {
    merged.scanned = saved.scanned;
  }
  const freshPages = fresh.pages ?? [];
  const savedPages = saved.pages ?? [];
  if (freshPages.length > 0 && samePageStructure(freshPages, savedPages)) {
    merged.currentPage = saved.currentPage ?? fresh.currentPage;
    merged.pages = freshPages.map(
      (page2, index) => carryAnswer(page2, savedPages[index])
    );
  } else if (
    // Through messageDeliveryFor, not the raw config: a story switched back
    // to the standard player keeps the ordinary rule for every point.
    messageDeliveryFor(fresh, settings) && !completed && samePrefix(freshPages, savedPages, saved.currentPage ?? 0)
  ) {
    const cursor = Math.min(saved.currentPage ?? 0, freshPages.length - 1);
    merged.currentPage = cursor;
    merged.pages = freshPages.map(
      (page2, index) => index < cursor ? carryAnswer(page2, savedPages[index]) : page2
    );
    if (cursor < freshPages.length - 1 || saved.currentPage !== cursor) {
      merged.viewed = false;
    }
  } else if (completed && freshPages.length > 0) {
    merged.currentPage = freshPages.length - 1;
  }
  return merged;
}
function reconcileStoryPoints(freshPoints, savedPoints, settings) {
  const savedByCode = new Map(savedPoints.map((point) => [point.code, point]));
  const freshCodes = new Set(freshPoints.map((point) => point.code));
  const result = freshPoints.map((fresh) => {
    const saved = savedByCode.get(fresh.code);
    return saved ? mergePoint(fresh, saved, settings) : fresh;
  });
  let insertAt = 0;
  for (const saved of savedPoints) {
    if (freshCodes.has(saved.code)) {
      insertAt = result.findIndex((point) => point.code === saved.code) + 1;
      continue;
    }
    if (saved.status !== "completed") continue;
    result.splice(insertAt, 0, { ...saved, removedFromTrail: true });
    insertAt += 1;
  }
  return result;
}

// src/zodSchemas/dbRows.ts
import { z as z7 } from "zod";
var uuid = z7.uuid();
var timestamp = z7.string();
var trailRowSchema = z7.object({
  id: uuid,
  created_at: timestamp,
  version: z7.number(),
  config: z7.nullable(
    z7.record(z7.string(), z7.union([z7.string(), z7.boolean(), z7.number()]))
  ),
  Name: z7.nullable(z7.string())
});
var storyRowSchema = z7.object({
  id: uuid,
  created_at: timestamp,
  trail: uuid,
  code: z7.string().min(8),
  title: z7.string(),
  accessToken: z7.nullable(z7.string()),
  // The stories.config column holds story SETTINGS.
  config: z7.nullable(storySettingsSchema),
  description: z7.nullable(z7.string()),
  image: z7.nullable(z7.string())
});
var storyPointRowSchema = z7.object({
  id: uuid,
  created_at: timestamp,
  code: z7.nullable(z7.string()),
  title: z7.string(),
  type: z7.enum(["introduction", "location", "conclusion", "narrative"]),
  pages: z7.nullable(z7.array(page)),
  config: z7.nullable(storyPointConfigSchema),
  order: z7.number(),
  story: uuid
});
var basePointRow = z7.object({
  id: uuid,
  created_at: timestamp,
  trail: uuid,
  code: z7.string().min(8)
});
var pointRowSchema = z7.discriminatedUnion("type", [
  basePointRow.extend({
    type: z7.literal("location"),
    lat: z7.number().min(-90).max(90),
    lng: z7.number().min(-180).max(180),
    title: z7.nullable(z7.string()),
    address: z7.nullable(z7.string()),
    locationImage: z7.nullable(z7.string()),
    redirectUrl: z7.nullable(z7.string()),
    accessToken: z7.nullable(z7.string()),
    story: z7.nullable(uuid)
  }),
  basePointRow.extend({
    type: z7.literal("urlRedirect"),
    lat: z7.nullable(z7.number()),
    lng: z7.nullable(z7.number()),
    title: z7.nullable(z7.string()),
    address: z7.nullable(z7.string()),
    locationImage: z7.nullable(z7.string()),
    redirectUrl: z7.nullable(z7.string()),
    accessToken: z7.nullable(z7.string()),
    story: z7.nullable(uuid)
  }),
  basePointRow.extend({
    type: z7.literal("story"),
    lat: z7.nullable(z7.number()),
    lng: z7.nullable(z7.number()),
    title: z7.nullable(z7.string()),
    address: z7.nullable(z7.string()),
    locationImage: z7.nullable(z7.string()),
    redirectUrl: z7.nullable(z7.string()),
    accessToken: z7.nullable(z7.string()),
    story: z7.nullable(uuid)
  })
]);
var mediaRowSchema = z7.object({
  id: uuid,
  created_at: z7.nullable(timestamp),
  bucket: z7.string(),
  object_name: z7.string(),
  title: z7.nullable(z7.string()),
  description: z7.nullable(z7.string()),
  kind: z7.nullable(z7.string()),
  type: z7.nullable(z7.string()),
  // text since the WorkOS migration (was uuid).
  owner_id: z7.nullable(z7.string()),
  story_template_id: z7.nullable(uuid)
});

// src/zodSchemas/templates.ts
import { z as z8 } from "zod";
var templateKey = z8.string().min(1).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "keys are kebab-case slugs");
var templateLocationDefaultSchema = z8.object({
  lat: z8.number().min(-90).max(90),
  lng: z8.number().min(-180).max(180),
  title: z8.nullable(z8.string()),
  address: z8.nullable(z8.string()),
  // The physical sign variant of the source location point. Absent means a
  // plain QR location sign (back-compat: older snapshots carry no signType).
  // 'arMarker' signs additionally carry markerSizeMm (the printed frame size,
  // the AR tracker's metric scale reference) so the instantiator can recreate
  // the matching point variant instead of collapsing everything to 'location'.
  signType: z8.optional(z8.enum(["location", "arMarker"])),
  // Only meaningful for arMarker signs; when present it must be a valid
  // printed-frame size (matches the arMarkerPage constraint). The plain
  // 'location' path is untouched — it never carries this field.
  markerSizeMm: z8.optional(z8.number().int().min(50).max(1e3))
}).superRefine((loc, ctx) => {
  if (loc.signType === "arMarker" && loc.markerSizeMm === void 0) {
    ctx.addIssue({
      code: "custom",
      path: ["markerSizeMm"],
      message: "arMarker location defaults require markerSizeMm"
    });
  }
  if (loc.signType !== "arMarker" && loc.markerSizeMm !== void 0) {
    ctx.addIssue({
      code: "custom",
      path: ["markerSizeMm"],
      message: "markerSizeMm is only valid on arMarker location defaults"
    });
  }
});
var templateStoryPointSchema = z8.object({
  key: templateKey,
  title: z8.string(),
  type: z8.enum(["introduction", "location", "conclusion", "narrative"]),
  order: z8.number(),
  pages: z8.nullable(z8.array(page)),
  // unlockRules.requiredPoints and delivery.linksTo hold storyPoint KEYS
  // inside a snapshot (the instantiator remaps them to freshly minted codes).
  config: z8.nullable(storyPointConfigSchema),
  // A NON-location point that carried a code in the source trail (a phone
  // shell message point, which other points reference by code). Codes are
  // instance fields and are stripped, so this is how the instantiator knows to
  // mint it a fresh one. Optional: older snapshots, and every point that never
  // had a code, leave it out. Location points get their code from their
  // physical point and never need it.
  hasCode: z8.optional(z8.literal(true)),
  // For location-type points: the source trail's coordinates, kept as the
  // default so duplicating a trail preserves its layout. The wizard replaces
  // these via location slots.
  defaultLocation: z8.optional(templateLocationDefaultSchema)
});
var templateStorySchema = z8.object({
  key: templateKey,
  title: z8.string(),
  description: z8.nullable(z8.string()),
  settings: z8.nullable(storySettingsSchema),
  storyPoints: z8.array(templateStoryPointSchema)
});
var placeholderKindSchema = z8.enum([
  "text",
  "richText",
  "image",
  "question",
  "location"
]);
var placeholderTargetSchema = z8.object({
  storyKey: templateKey,
  storyPointKey: templateKey,
  /**
   * Path into the storyPoint using the constrained grammar of
   * templates/paths.ts, e.g. 'pages[2].image' or 'title'. Absent for
   * kind 'location' (the wizard's map step consumes those directly).
   */
  path: z8.optional(z8.string()),
  /**
   * 'field': replace the whole value at path.
   * 'token': substitute occurrences of '{{key}}' inside the string at path —
   * for names woven into prose.
   */
  mode: z8.enum(["field", "token"])
});
var placeholderSchema = z8.object({
  key: z8.string().min(1),
  /** Customer-facing label in the wizard, e.g. "Your school name". */
  label: z8.string(),
  description: z8.optional(z8.string()),
  kind: placeholderKindSchema,
  required: z8.boolean(),
  defaultValue: z8.optional(z8.unknown()),
  targets: z8.array(placeholderTargetSchema)
}).superRefine((placeholder, ctx) => {
  if (placeholder.kind === "location") return;
  placeholder.targets.forEach((target2, index) => {
    if (!target2.path) {
      ctx.addIssue({
        code: "custom",
        path: ["targets", index, "path"],
        message: `${placeholder.kind} placeholder targets require a path`
      });
    }
  });
});
var questionPlaceholderValueSchema = z8.object({
  question: z8.string().min(1),
  choices: z8.optional(z8.array(z8.string())),
  answer: z8.string().min(1)
});
var locationPlaceholderValueSchema = z8.object({
  lat: z8.number().min(-90).max(90),
  lng: z8.number().min(-180).max(180),
  title: z8.optional(z8.string()),
  address: z8.optional(z8.string())
});
var trailTemplateSnapshotSchema = z8.object({
  config: trailConfigSchema,
  stories: z8.array(templateStorySchema),
  placeholders: z8.array(placeholderSchema)
}).superRefine((snapshot, ctx) => {
  const storyKeys = /* @__PURE__ */ new Set();
  snapshot.stories.forEach((story, storyIndex) => {
    if (storyKeys.has(story.key)) {
      ctx.addIssue({
        code: "custom",
        path: ["stories", storyIndex, "key"],
        message: `duplicate story key "${story.key}"`
      });
    }
    storyKeys.add(story.key);
    const allPointKeys = new Set(story.storyPoints.map((p) => p.key));
    const pointKeys = /* @__PURE__ */ new Set();
    story.storyPoints.forEach((point, pointIndex) => {
      if (pointKeys.has(point.key)) {
        ctx.addIssue({
          code: "custom",
          path: ["stories", storyIndex, "storyPoints", pointIndex, "key"],
          message: `duplicate storyPoint key "${point.key}" in story "${story.key}"`
        });
      }
      pointKeys.add(point.key);
      const unlockRules = point.config?.unlockRules;
      if (unlockRules?.type === "completedPoints") {
        unlockRules.requiredPoints.forEach((ref, refIndex) => {
          if (!allPointKeys.has(ref)) {
            ctx.addIssue({
              code: "custom",
              path: [
                "stories",
                storyIndex,
                "storyPoints",
                pointIndex,
                "config",
                "unlockRules",
                "requiredPoints",
                refIndex
              ],
              message: `unlock rule references unknown storyPoint "${ref}" in story "${story.key}"`
            });
          }
        });
      }
      const linksTo = point.config?.delivery?.linksTo;
      if (linksTo !== void 0 && !allPointKeys.has(linksTo)) {
        ctx.addIssue({
          code: "custom",
          path: [
            "stories",
            storyIndex,
            "storyPoints",
            pointIndex,
            "config",
            "delivery",
            "linksTo"
          ],
          message: `message link references unknown storyPoint "${linksTo}" in story "${story.key}"`
        });
      }
    });
  });
  const placeholderKeys = /* @__PURE__ */ new Set();
  snapshot.placeholders.forEach((placeholder, index) => {
    if (placeholderKeys.has(placeholder.key)) {
      ctx.addIssue({
        code: "custom",
        path: ["placeholders", index, "key"],
        message: `duplicate placeholder key "${placeholder.key}"`
      });
    }
    placeholderKeys.add(placeholder.key);
    placeholder.targets.forEach((target2, targetIndex) => {
      const story = snapshot.stories.find((s) => s.key === target2.storyKey);
      if (!story) {
        ctx.addIssue({
          code: "custom",
          path: ["placeholders", index, "targets", targetIndex, "storyKey"],
          message: `target references unknown story "${target2.storyKey}"`
        });
        return;
      }
      if (!story.storyPoints.some((p) => p.key === target2.storyPointKey)) {
        ctx.addIssue({
          code: "custom",
          path: [
            "placeholders",
            index,
            "targets",
            targetIndex,
            "storyPointKey"
          ],
          message: `target references unknown storyPoint "${target2.storyPointKey}" in story "${target2.storyKey}"`
        });
      }
    });
  });
});

// src/templates/paths.ts
var SEGMENT_PATTERN = /^([A-Za-z_$][\w$]*)(\[(\d+)\])?$/;
var InvalidPathError = class extends Error {
  constructor(path, reason) {
    super(`Invalid path "${path}": ${reason}`);
    this.name = "InvalidPathError";
  }
};
function parsePath(path) {
  if (!path) {
    throw new InvalidPathError(path, "path is empty");
  }
  return path.split(".").map((raw) => {
    const match = SEGMENT_PATTERN.exec(raw);
    if (!match) {
      throw new InvalidPathError(path, `bad segment "${raw}"`);
    }
    const segment = { key: match[1] };
    if (match[3] !== void 0) {
      segment.index = Number(match[3]);
    }
    return segment;
  });
}
function step(target2, segment, path) {
  if (target2 === null || typeof target2 !== "object") {
    throw new InvalidPathError(
      path,
      `cannot read "${segment.key}" of ${target2 === null ? "null" : typeof target2}`
    );
  }
  const byKey = target2[segment.key];
  if (segment.index === void 0) {
    return byKey;
  }
  if (!Array.isArray(byKey)) {
    throw new InvalidPathError(path, `"${segment.key}" is not an array`);
  }
  return byKey[segment.index];
}
function getAtPath(target2, path) {
  return parsePath(path).reduce(
    (current, segment) => step(current, segment, path),
    target2
  );
}
function setAtPath(target2, path, value) {
  const segments = parsePath(path);
  const last = segments[segments.length - 1];
  let container = target2;
  for (const segment of segments.slice(0, -1)) {
    container = step(container, segment, path);
  }
  if (container === null || typeof container !== "object") {
    throw new InvalidPathError(path, "parent is not an object");
  }
  if (last.index === void 0) {
    container[last.key] = value;
    return;
  }
  const arr = container[last.key];
  if (!Array.isArray(arr)) {
    throw new InvalidPathError(path, `"${last.key}" is not an array`);
  }
  if (last.index >= arr.length) {
    throw new InvalidPathError(
      path,
      `index ${last.index} out of bounds for "${last.key}"`
    );
  }
  arr[last.index] = value;
}

// src/templates/applyPlaceholders.ts
var ApplyPlaceholderError = class extends Error {
  constructor(placeholderKey, reason) {
    super(`Placeholder "${placeholderKey}": ${reason}`);
    this.placeholderKey = placeholderKey;
    this.name = "ApplyPlaceholderError";
  }
};
function findStoryPoint(snapshot, storyKey, storyPointKey, placeholderKey) {
  const story = snapshot.stories.find((s) => s.key === storyKey);
  if (!story) {
    throw new ApplyPlaceholderError(
      placeholderKey,
      `story "${storyKey}" not found in snapshot`
    );
  }
  const storyPoint = story.storyPoints.find((p) => p.key === storyPointKey);
  if (!storyPoint) {
    throw new ApplyPlaceholderError(
      placeholderKey,
      `storyPoint "${storyPointKey}" not found in story "${storyKey}"`
    );
  }
  return storyPoint;
}
function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function applyTokenBatch(batch) {
  const current = getAtPath(batch.storyPoint, batch.path);
  if (typeof current !== "string") {
    throw new ApplyPlaceholderError(
      batch.placeholderKey,
      `token target "${batch.path}" is not a string`
    );
  }
  const pattern = [...batch.values.keys()].map(escapeRegExp).join("|");
  const regex = new RegExp(`\\{\\{(${pattern})\\}\\}`, "g");
  const replaced = current.replace(regex, (match, key) => {
    const value = batch.values.get(key);
    return value !== void 0 ? value : match;
  });
  setAtPath(batch.storyPoint, batch.path, replaced);
}
function applyToTarget(storyPoint, placeholder, path, value) {
  if (placeholder.kind === "question") {
    const parsed = questionPlaceholderValueSchema.safeParse(value);
    if (!parsed.success) {
      throw new ApplyPlaceholderError(
        placeholder.key,
        `question value is invalid: ${parsed.error.issues[0]?.message}`
      );
    }
    const target2 = getAtPath(storyPoint, path);
    if (target2 === null || typeof target2 !== "object" || target2.type !== "question") {
      throw new ApplyPlaceholderError(
        placeholder.key,
        `question target "${path}" is not a question page`
      );
    }
    Object.assign(target2, parsed.data);
    return;
  }
  setAtPath(storyPoint, path, value);
}
function applyPlaceholders(snapshot, values) {
  const result = structuredClone(snapshot);
  const touched = /* @__PURE__ */ new Set();
  const tokenBatches = /* @__PURE__ */ new Map();
  const batchKeys = /* @__PURE__ */ new Map();
  for (const placeholder of result.placeholders) {
    if (placeholder.kind === "location") continue;
    const value = values[placeholder.key] ?? placeholder.defaultValue;
    if (value === void 0) continue;
    for (const target2 of placeholder.targets) {
      if (!target2.path) {
        throw new ApplyPlaceholderError(
          placeholder.key,
          "non-location target is missing a path"
        );
      }
      const storyPoint = findStoryPoint(
        result,
        target2.storyKey,
        target2.storyPointKey,
        placeholder.key
      );
      if (target2.mode === "token") {
        if (!batchKeys.has(storyPoint)) {
          batchKeys.set(storyPoint, batchKeys.size);
        }
        const batchKey = `${batchKeys.get(storyPoint)}::${target2.path}`;
        let batch = tokenBatches.get(batchKey);
        if (!batch) {
          batch = {
            storyPoint,
            path: target2.path,
            values: /* @__PURE__ */ new Map(),
            placeholderKey: placeholder.key
          };
          tokenBatches.set(batchKey, batch);
        }
        batch.values.set(placeholder.key, String(value));
      } else {
        applyToTarget(storyPoint, placeholder, target2.path, value);
      }
      touched.add(storyPoint);
    }
  }
  for (const batch of tokenBatches.values()) {
    applyTokenBatch(batch);
  }
  for (const storyPoint of touched) {
    for (const [index, candidate] of (storyPoint.pages ?? []).entries()) {
      const check = page.safeParse(candidate);
      if (!check.success) {
        throw new ApplyPlaceholderError(
          "validation",
          `storyPoint "${storyPoint.key}" page ${index} is invalid after substitution: ${check.error.issues[0]?.message}`
        );
      }
      storyPoint.pages[index] = check.data;
    }
  }
  return result;
}

// src/templates/validateDraft.ts
function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}
function validateDraft(snapshot, values, locations = {}) {
  const issues = [];
  for (const placeholder of snapshot.placeholders) {
    const { key, kind, label } = placeholder;
    if (kind === "location") {
      const location = locations[key];
      if (location === void 0) {
        if (placeholder.required) {
          issues.push({
            placeholderKey: key,
            problem: "missing",
            message: `"${label}" has not been placed on the map`
          });
        }
        continue;
      }
      if (!locationPlaceholderValueSchema.safeParse(location).success) {
        issues.push({
          placeholderKey: key,
          problem: "invalid",
          message: `"${label}" has invalid coordinates`
        });
      }
      continue;
    }
    const value = values[key] ?? placeholder.defaultValue;
    if (value === void 0) {
      if (placeholder.required) {
        issues.push({
          placeholderKey: key,
          problem: "missing",
          message: `"${label}" has not been filled in`
        });
      }
      continue;
    }
    switch (kind) {
      case "text":
      case "richText":
      case "image":
        if (!isNonEmptyString(value)) {
          issues.push({
            placeholderKey: key,
            problem: "invalid",
            message: `"${label}" must be a non-empty ${kind === "image" ? "image URL" : "text value"}`
          });
        }
        break;
      case "question":
        if (!questionPlaceholderValueSchema.safeParse(value).success) {
          issues.push({
            placeholderKey: key,
            problem: "invalid",
            message: `"${label}" needs a question and an answer`
          });
        }
        break;
    }
  }
  return { valid: issues.length === 0, issues };
}

// src/templates/fieldManifest.ts
var GAME_BASE_FIELDS = {
  title: "text",
  backgroundImage: "image",
  instructions: "richText",
  instructionsImage: "image",
  completeImage: "image",
  completeTitle: "text",
  completeText: "richText",
  wrongAnswerImage: "image",
  wrongAnswerTitle: "text",
  wrongAnswerText: "richText"
};
var fieldManifest = {
  pageLayout01: {
    title: "text",
    image: "image",
    altText: "text",
    content: "richText",
    closeButtonText: "text"
  },
  pageLayout02: {
    title: "text",
    image: "image",
    altText: "text",
    content: "richText",
    closeButtonText: "text"
  },
  pageReveal01: {
    title: "text",
    backgroundImage: "image",
    objectImage: "image",
    objectSplitTopImage: "image",
    objectSplitBottomImage: "image",
    revealedImage: "image"
  },
  question: {
    title: "text",
    question: "text",
    answer: "text",
    choices: "textArray",
    backgroundImage: "image",
    questionImage: "image",
    correctAnswerImage: "image",
    wrongAnswerImage: "image",
    completeText: "richText",
    wrongAnswerText: "richText"
  },
  iframe: {
    title: "text",
    iframeUrl: "text"
  },
  starburst: {
    title: "text",
    image: "image",
    starburstImage: "image",
    backgroundImage: "image",
    altText: "text",
    content: "richText"
  },
  showcase3d: {
    title: "text",
    content: "richText",
    backgroundImage: "image",
    altText: "text"
  },
  crackerReveal: {
    title: "text",
    instructions: "text",
    backgroundImage: "image",
    revealImage: "image",
    altText: "text"
  },
  tapTheThingGame: {
    ...GAME_BASE_FIELDS,
    images: "imageArray"
  },
  slidingTilePuzzleGame: {
    ...GAME_BASE_FIELDS,
    image: "image"
  },
  imageSliceMatcherGame: {
    ...GAME_BASE_FIELDS,
    images: "imageArray"
  },
  decoderRingGame: {
    ...GAME_BASE_FIELDS,
    message: "text"
  },
  visionMatch: {
    ...GAME_BASE_FIELDS,
    visionMatchImages: "imageArray",
    scannerHint: "text",
    hiddenText: "text",
    hiddenImage: "image",
    skipQuestion: "text",
    skipQuestionAnswer: "text"
  },
  // Object Scanner: the thing to find, its confidence and hold are design
  // choices; the copy and the on-screen hint are customer content.
  objectScan: {
    ...GAME_BASE_FIELDS,
    scannerHint: "text",
    skipQuestion: "text",
    skipQuestionAnswer: "text"
  },
  snapChase: {
    ...GAME_BASE_FIELDS,
    panoImageUrl: "image"
  },
  locationCheck: {
    title: "text",
    content: "richText",
    image: "image",
    backgroundImage: "image"
  },
  // Media URLs are 'text' placeholders, matching the iframeUrl precedent —
  // the media library / FieldKind system has no audio/video kind yet.
  audioPage: {
    title: "text",
    image: "image",
    altText: "text",
    content: "richText",
    audioUrl: "text",
    transcript: "richText",
    closeButtonText: "text"
  },
  videoPage: {
    title: "text",
    videoUrl: "text",
    posterImage: "image",
    caption: "text"
  },
  selfie: {
    title: "text",
    instructions: "text"
  },
  arShooterGame: {
    ...GAME_BASE_FIELDS,
    // Revealed when the optional reward chest opens: a clue or a code word,
    // so it is customer content a localised copy has to be able to change.
    rewardText: "text"
  },
  sliceGame: {
    ...GAME_BASE_FIELDS,
    images: "imageArray",
    bombImages: "imageArray"
  },
  whackGame: {
    ...GAME_BASE_FIELDS,
    images: "imageArray",
    decoyImages: "imageArray"
  },
  targetTossGame: {
    ...GAME_BASE_FIELDS,
    targetImages: "imageArray",
    projectileImage: "image"
  },
  stackGame: {
    ...GAME_BASE_FIELDS,
    blockImage: "image"
  },
  // Wheel segments (values/labels/colours) are game-design choices, not
  // customer content, so only the shared base fields are placeholder-able.
  spinWheelGame: {
    ...GAME_BASE_FIELDS
  },
  basketCatchGame: {
    ...GAME_BASE_FIELDS,
    itemImages: "imageArray",
    basketImage: "image"
  },
  memoryPairsGame: {
    ...GAME_BASE_FIELDS,
    images: "imageArray"
  },
  tiltMazeGame: {
    ...GAME_BASE_FIELDS,
    ballImage: "image"
  },
  // theme / target / moteCount are game-design choices, not customer
  // content, so only the shared base (title, instructions, images) is exposed.
  luminaGame: {
    ...GAME_BASE_FIELDS
  },
  // QR Checkpoint: content fields are placeholder-able so a template can carry
  // the copy/imagery while leaving the location-specific expectedValue and the
  // wrong-scan copy for the customer to fill in. matchMode/caseSensitive are
  // configuration, not content, so they are not exposed here.
  qrCheck: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    expectedValue: "text",
    wrongScanTitle: "text",
    wrongScanText: "text"
  },
  // AR Marker: content/copy fields are placeholder-able so a template can carry
  // the imagery and copy. object / markerSizeMm / mount / dwellSeconds / display
  // / windowScene are configuration (tied to the physical printed sign), not
  // customer content, so they are not exposed here. panoImageUrl IS content (the
  // 360° image shown behind a window-mode portal), so a template can leave it for
  // the customer to fill in — matching the snapChase precedent.
  arMarker: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    panoImageUrl: "image"
  },
  // Fairy Encounter: copy/imagery plus the creature's display name are
  // customer content. Appearance, anchoring and placement are experience
  // design choices tied to the venue, so they are not exposed here.
  fairyEncounter: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    creatureName: "text",
    targetImageUrl: "image"
  },
  // Melody Game: copy/imagery is placeholder-able so a template can carry the
  // character and wording. instrument / sequence are game-design choices tied
  // to the puzzle, not customer content, so they are not exposed here.
  melodyGame: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    characterImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText"
  },
  // Number Lock: everything the customer would localise — where to look, the
  // code itself (it is tied to the real-world plaque/sign at the location),
  // the hint and the payoff copy/imagery. lockStyle is a design choice.
  numberLock: {
    title: "text",
    code: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    lockPrompt: "text",
    plateText: "text",
    hint: "richText",
    completeTitle: "text",
    completeText: "richText",
    completeImage: "image",
    revealImage: "image"
  },
  // Cipher Lock: the answer and key are tied to the real-world clue at the
  // location, so they are localisable like numberLock.code. shift is a
  // number and stays a template design choice alongside it — but the answer
  // must be re-authored with it, so both are exposed as text.
  cipherLock: {
    title: "text",
    answer: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    lockPrompt: "text",
    hint: "richText",
    completeTitle: "text",
    completeText: "richText",
    completeImage: "image",
    revealImage: "image"
  },
  // Signal Detector: copy/imagery and what the detector is "tuned to" are
  // customer content; the theme and distances are experience design choices.
  signalDetector: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    signalName: "text"
  },
  // Treasure Chest: the lock half mirrors numberLock (the code is tied to the
  // real-world clue), plus the chest's display name. Distances are design.
  treasureChest: {
    title: "text",
    code: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    chestName: "text",
    lockPrompt: "text",
    plateText: "text",
    hint: "richText",
    completeTitle: "text",
    completeText: "richText",
    completeImage: "image",
    revealImage: "image"
  },
  // Sign Reveal: copy/imagery, the sign photo (tied to the venue) and the
  // revealed text (a code tied to the trail's next lock) are customer
  // content. Theme, target kind and the reveal object are design choices.
  signReveal: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    scannerHint: "text",
    targetImageUrl: "image",
    revealText: "text"
  },
  // Spell Cast: copy/imagery and what the spell is called are customer
  // content; the shape, wand, theme and guide are experience design choices.
  spellCast: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    spellName: "text"
  },
  // The character pages: copy, imagery, names and the photo caption are
  // content; which creature appears and how it moves are design choices.
  snapChaseAR: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    photoCaption: "text"
  },
  creaturePhoto: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    creatureName: "text",
    photoCaption: "text"
  },
  feedingGame: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    creatureName: "text",
    // Revealed when the optional reward chest opens (see arShooterGame).
    rewardText: "text"
  },
  // Chomp: copy, imagery and the payoff text are content; the food, the
  // number of feeds, how many faces and the camera are design choices.
  arChomp: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    // Revealed on the completion card (see feedingGame).
    rewardText: "text"
  },
  // Cauldron Brew: copy, imagery, the riddle and the payoff text are content;
  // the recipe, decoys and order rule are the puzzle design.
  cauldronBrew: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    riddle: "text",
    rewardText: "text"
  },
  // Haunted Tower: copy, imagery and the payoff text are content; what the
  // tower is built from and how tall it is are design choices.
  towerToppleGame: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    rewardText: "text"
  },
  // Magic Mirror: copy, imagery, the collected word and the payoff text are
  // customer content. The theme, goal and item count are design choices.
  magicMirror: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    completeImage: "image",
    completeTitle: "text",
    completeText: "richText",
    word: "text",
    revealText: "text"
  },
  // NFC Tap: copy and imagery are customer content. The token and the fallback
  // code are deliberately absent: the token is machinery (it has to match what
  // is written on the physical tag, so localising it would break every tag),
  // and the fallback code is printed on the poster alongside it.
  nfcTap: {
    title: "text",
    instructions: "richText",
    instructionsImage: "image",
    backgroundImage: "image",
    scanPrompt: "text",
    hint: "richText",
    completeTitle: "text",
    completeText: "richText",
    completeImage: "image",
    revealImage: "image"
  }
};

// src/templates/templateVariables.ts
var VARIABLE_SOURCE = "\\{\\{([a-z][a-z0-9_]*)\\}\\}";
function variableRegex() {
  return new RegExp(VARIABLE_SOURCE, "g");
}
var TEXT_FIELD_KINDS = /* @__PURE__ */ new Set([
  "text",
  "richText",
  "textArray"
]);
var URL_TEXT_FIELDS = /* @__PURE__ */ new Set([
  "iframeUrl",
  "audioUrl",
  "videoUrl"
]);
function visitStringField(container, field, kind, visit, location, maxLength) {
  if (!container || typeof container !== "object") return;
  const record = container;
  const value = record[field];
  if (typeof value !== "string") return;
  visit(
    value,
    kind,
    (next) => {
      const stored = maxLength === void 0 ? next : next.slice(0, maxLength).trimEnd();
      record[field] = stored;
      return stored;
    },
    location
  );
}
var PHONE_NAME_MAX = 40;
var PHONE_ROLE_MAX = 60;
var PHONE_APP_LABEL_MAX = 24;
var ATTACHMENT_LABEL_MAX = 60;
function walkStorySettingsText(settings, visit, locationPrefix) {
  if (!settings || typeof settings !== "object") return;
  const phone = settings.phone;
  if (!phone || typeof phone !== "object") return;
  const { apps, senders, threads } = phone;
  if (Array.isArray(apps)) {
    apps.forEach(
      (app, index) => visitStringField(
        app,
        "label",
        "plain",
        visit,
        `${locationPrefix}phone.apps[${index}].label`,
        PHONE_APP_LABEL_MAX
      )
    );
  }
  for (const [group2, entries] of [
    ["senders", senders],
    ["threads", threads]
  ]) {
    if (!entries || typeof entries !== "object") continue;
    for (const [key, entry] of Object.entries(entries)) {
      const location = `${locationPrefix}phone.${group2}.${key}`;
      visitStringField(
        entry,
        "name",
        "plain",
        visit,
        `${location}.name`,
        PHONE_NAME_MAX
      );
      if (group2 === "senders") {
        visitStringField(
          entry,
          "role",
          "plain",
          visit,
          `${location}.role`,
          PHONE_ROLE_MAX
        );
      }
    }
  }
}
function walkStoryPointConfigText(config, visit, locationPrefix) {
  if (!config || typeof config !== "object") return;
  visitStringField(
    config.delivery,
    "attachmentLabel",
    "plain",
    visit,
    `${locationPrefix}delivery.attachmentLabel`,
    ATTACHMENT_LABEL_MAX
  );
}
function walkTextFields(snapshot, visit) {
  for (const story of snapshot.stories) {
    visitStringField(story, "title", "plain", visit, `${story.key} \u203A title`);
    visitStringField(
      story,
      "description",
      "plain",
      visit,
      `${story.key} \u203A description`
    );
    walkStorySettingsText(story.settings, visit, `${story.key} \u203A `);
    for (const storyPoint of story.storyPoints) {
      const pointLocation = `${story.key} \u203A ${storyPoint.key}`;
      visitStringField(
        storyPoint,
        "title",
        "plain",
        visit,
        `${pointLocation} \u203A title`
      );
      walkStoryPointConfigText(storyPoint.config, visit, `${pointLocation} \u203A `);
      walkPagesText(storyPoint.pages, visit, `${pointLocation} \u203A `);
    }
  }
}
function walkPagesText(pages, visit, locationPrefix) {
  if (!Array.isArray(pages)) return;
  for (const [pageIndex, page2] of pages.entries()) {
    if (!page2 || typeof page2 !== "object") continue;
    const type = page2.type;
    if (typeof type !== "string") continue;
    const manifest = fieldManifest[type];
    if (!manifest) continue;
    for (const [field, kind] of Object.entries(manifest)) {
      if (!TEXT_FIELD_KINDS.has(kind)) continue;
      if (kind === "text" && URL_TEXT_FIELDS.has(field)) continue;
      const textKind = kind === "richText" ? "richText" : "plain";
      const fieldLocation = `${locationPrefix}pages[${pageIndex}].${field}`;
      if (kind === "textArray") {
        const arr = page2[field];
        if (!Array.isArray(arr)) continue;
        arr.forEach((item, index) => {
          if (typeof item !== "string") return;
          visit(
            item,
            textKind,
            (next) => {
              arr[index] = next;
              return next;
            },
            `${fieldLocation}[${index}]`
          );
        });
        continue;
      }
      visitStringField(page2, field, textKind, visit, fieldLocation);
    }
  }
}
function detectVariables(snapshot) {
  const found = /* @__PURE__ */ new Set();
  walkTextFields(snapshot, (text) => {
    for (const match of text.matchAll(variableRegex())) {
      found.add(match[1]);
    }
  });
  return [...found].sort();
}
function escapeHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function substituteVariables(snapshot, values) {
  const result = structuredClone(snapshot);
  walkTextFields(result, (text, kind, set) => {
    const replaced = text.replace(variableRegex(), (match, key) => {
      const value = values[key];
      if (value === void 0) return match;
      return kind === "richText" ? escapeHtml(value) : value;
    });
    if (replaced !== text) set(replaced);
  });
  return result;
}
var EXCERPT_RADIUS = 40;
function excerptAround(text, index, length) {
  const start = Math.max(0, index - EXCERPT_RADIUS);
  const end = Math.min(text.length, index + length + EXCERPT_RADIUS);
  return `${start > 0 ? "\u2026" : ""}${text.slice(start, end)}${end < text.length ? "\u2026" : ""}`;
}
function replaceVisitor(search, replacement, changes) {
  return (text, _kind, set, location) => {
    const first = text.indexOf(search);
    if (first === -1) return;
    const parts = text.split(search);
    const stored = set(parts.join(replacement));
    changes.push({
      location,
      count: parts.length - 1,
      excerpt: excerptAround(
        stored,
        Math.min(first, stored.length),
        replacement.length
      )
    });
  };
}
function scanSnapshotText(snapshot, search) {
  const needle = search.toLowerCase();
  const matches = [];
  if (!needle) return matches;
  walkTextFields(snapshot, (text, _kind, _set, location) => {
    const haystack = text.toLowerCase();
    const first = haystack.indexOf(needle);
    if (first === -1) return;
    let count = 0;
    for (let at = first; at !== -1; at = haystack.indexOf(needle, at + needle.length)) {
      count += 1;
    }
    matches.push({
      location,
      count,
      excerpt: excerptAround(text, first, search.length)
    });
  });
  return matches;
}
function replaceSnapshotText(snapshot, search, replacement) {
  const result = structuredClone(snapshot);
  const changes = [];
  if (!search) return { snapshot: result, changes };
  walkTextFields(result, replaceVisitor(search, replacement, changes));
  return { snapshot: result, changes };
}
function replacePagesText(pages, search, replacement) {
  const result = structuredClone(pages);
  const changes = [];
  if (!search) return { pages: result, changes };
  walkPagesText(result, replaceVisitor(search, replacement, changes), "");
  return { pages: result, changes };
}
function replaceStorySettingsText(settings, search, replacement) {
  const result = structuredClone(settings);
  const changes = [];
  if (!search) return { settings: result, changes };
  walkStorySettingsText(
    result,
    replaceVisitor(search, replacement, changes),
    ""
  );
  return { settings: result, changes };
}
function replaceStoryPointConfigText(config, search, replacement) {
  const result = structuredClone(config);
  const changes = [];
  if (!search) return { config: result, changes };
  walkStoryPointConfigText(
    result,
    replaceVisitor(search, replacement, changes),
    ""
  );
  return { config: result, changes };
}
function prettifyVariableKey(key) {
  const spaced = key.replace(/_/g, " ").trim();
  if (!spaced) return key;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

// src/typeGuards/typeGuards.ts
function isHydratedLocationStoryPoint(locationPoint) {
  return locationPoint.type === "location";
}
function isPageLayout01(page2) {
  return page2.type === "pageLayout01";
}
function isPageLayout02(page2) {
  return page2.type === "pageLayout02";
}
function isPageReveal01(page2) {
  return page2.type === "pageReveal01";
}
function isQuestionPage(page2) {
  return page2.type === "question";
}
function isIFramePage(page2) {
  return page2.type === "iframe";
}
function isStarburstPage(page2) {
  return page2.type === "starburst";
}
function isTapTheThingGamePage(page2) {
  return page2.type === "tapTheThingGame";
}
function isImageSliceMatcherGamePage(page2) {
  return page2.type === "imageSliceMatcherGame";
}
function isSlidingTilePuzzleGamePage(page2) {
  return page2.type === "slidingTilePuzzleGame";
}
function isDecoderRingGame(page2) {
  return page2.type === "decoderRingGame";
}
function isVisionMatchPage(page2) {
  return page2.type === "visionMatch";
}
function isObjectScanPage(page2) {
  return page2.type === "objectScan";
}
function isSnapChaseGame(page2) {
  return page2.type === "snapChase";
}
function isLocationCheckPage(page2) {
  return page2.type === "locationCheck";
}
function isAudioPage(page2) {
  return page2.type === "audioPage";
}
function isVideoPage(page2) {
  return page2.type === "videoPage";
}
function isSelfiePage(page2) {
  return page2.type === "selfie";
}
function isArShooterGame(page2) {
  return page2.type === "arShooterGame";
}
function isSliceGame(page2) {
  return page2.type === "sliceGame";
}
function isWhackGame(page2) {
  return page2.type === "whackGame";
}
function isTargetTossGame(page2) {
  return page2.type === "targetTossGame";
}
function isStackGame(page2) {
  return page2.type === "stackGame";
}
function isSpinWheelGame(page2) {
  return page2.type === "spinWheelGame";
}
function isBasketCatchGame(page2) {
  return page2.type === "basketCatchGame";
}
function isMemoryPairsGame(page2) {
  return page2.type === "memoryPairsGame";
}
function isTiltMazeGame(page2) {
  return page2.type === "tiltMazeGame";
}
function isLuminaGame(page2) {
  return page2.type === "luminaGame";
}
function isQRCheckPage(page2) {
  return page2.type === "qrCheck";
}
function isARMarkerPage(page2) {
  return page2.type === "arMarker";
}
function isMelodyGamePage(page2) {
  return page2.type === "melodyGame";
}
function isNumberLockPage(page2) {
  return page2.type === "numberLock";
}
function isCipherLockPage(page2) {
  return page2.type === "cipherLock";
}
function isFairyEncounterPage(page2) {
  return page2.type === "fairyEncounter";
}
function isShowcase3dPage(page2) {
  return page2.type === "showcase3d";
}
function isCrackerRevealPage(page2) {
  return page2.type === "crackerReveal";
}
function isSignalDetectorPage(page2) {
  return page2.type === "signalDetector";
}
function isTreasureChestPage(page2) {
  return page2.type === "treasureChest";
}
function isSignRevealPage(page2) {
  return page2.type === "signReveal";
}
function isSpellCastPage(page2) {
  return page2.type === "spellCast";
}
function isNfcTapPage(page2) {
  return page2.type === "nfcTap";
}
function isMagicMirrorPage(page2) {
  return page2.type === "magicMirror";
}
function isARChompPage(page2) {
  return page2.type === "arChomp";
}

// src/analytics/events.ts
var ANALYTICS_EVENTS = {
  /** Player: a trail was opened fresh from the public API. */
  loadTrail: "loadTrail",
  /** Player: a trail was reopened from the local (saved) cache. */
  loadSavedTrail: "loadSavedTrail",
  /** Player: a saved trail's in-progress state was restored. */
  restoreSavedTrail: "restoreSavedTrail",
  /** Player: a story point was completed. Carries a `storyPoint` property. */
  storyPointCompleted: "storyPointCompleted",
  /** Server (`.io`): the point API resolved a trail (origin fetches only —
   *  CDN cache hits never reach the capture). Carries `trail` + `code`. */
  requestTrail: "request-trail"
};
var TRAIL_START_EVENTS = [
  ANALYTICS_EVENTS.loadTrail,
  ANALYTICS_EVENTS.loadSavedTrail,
  ANALYTICS_EVENTS.restoreSavedTrail
];
var ANALYTICS_PROPERTY_KEYS = {
  /** `storyPointCompleted`: the completed point's code. */
  storyPoint: "storyPoint",
  /** `request-trail`: the trail id. */
  trail: "trail",
  /** `request-trail`: the scanned code. */
  code: "code"
};

// src/phoneShell/validate.ts
function hasKey(record, key) {
  return Object.prototype.hasOwnProperty.call(record, key);
}
function validateMessageDelivery(point, settings, storyPointCodes) {
  const delivery = point.config?.delivery;
  if (!delivery) return [];
  if (point.type === "location") {
    return [
      'A location point cannot be delivered as a message. Turn off "Deliver as a message" or change the content type.'
    ];
  }
  if (settings?.shell !== "phone" || delivery.channel !== "message") return [];
  const problems = [];
  if (!point.code) {
    problems.push("A message needs a code so the phone can keep track of it.");
  }
  if (!point.pages || point.pages.length === 0) {
    problems.push("A message needs at least one page.");
  }
  if (delivery.presentation !== void 0 && !messagePresentation.safeParse(delivery.presentation).success) {
    problems.push(
      `"${delivery.presentation}" is not a way a message can be shown.`
    );
  }
  const senders = settings.phone?.senders ?? {};
  if (!hasKey(senders, delivery.sender)) {
    problems.push(
      `The sender "${delivery.sender}" is not in this story's sender list.`
    );
  }
  if (delivery.thread !== void 0) {
    const threads = settings.phone?.threads ?? {};
    if (!hasKey(threads, delivery.thread)) {
      problems.push(
        `The group thread "${delivery.thread}" is not in this story's thread list.`
      );
    }
  }
  if (delivery.linksTo !== void 0) {
    const codes = /* @__PURE__ */ new Set();
    for (const code2 of storyPointCodes) {
      if (code2) codes.add(code2);
    }
    if (!codes.has(delivery.linksTo)) {
      problems.push(
        'The "Show on map" link points at a story point that is not in this story.'
      );
    } else if (delivery.linksTo === point.code) {
      problems.push(
        'The "Show on map" link cannot point at the message itself.'
      );
    }
  }
  return problems;
}
var PHONE_MAX_SENDERS = 50;
var PHONE_MAX_THREADS = 50;
var AVATAR_MAX_LENGTH = 4096;
var PHONE_KEY_PATTERN = /^[a-z0-9][a-z0-9-]{0,31}$/;
var RESERVED_PHONE_KEYS = /* @__PURE__ */ new Set([
  "constructor",
  "__proto__",
  "prototype",
  "hasownproperty",
  "tostring",
  "valueof"
]);
function isUsablePhoneKey(key) {
  return PHONE_KEY_PATTERN.test(key) && !RESERVED_PHONE_KEYS.has(key);
}
function isUsableAvatar(avatar) {
  if (avatar.length > AVATAR_MAX_LENGTH) return false;
  if (/^https?:\/\//i.test(avatar)) return true;
  return avatar.startsWith("/") && !avatar.startsWith("//");
}
function validatePhoneSettings(phone) {
  if (!phone) return [];
  const problems = [];
  if (phone.layout !== void 0 && !phoneLayout.safeParse(phone.layout).success) {
    problems.push(`"${phone.layout}" is not a phone layout.`);
  }
  for (const [name, value] of [
    ["accent colour", phone.colours?.accent],
    ["wallpaper tint", phone.colours?.wallpaper]
  ]) {
    if (value !== void 0 && !hexColour.safeParse(value).success) {
      problems.push(`The ${name} must be a hex colour such as #ff6a13.`);
    }
  }
  const groups = [
    ["senders", "sender", PHONE_MAX_SENDERS],
    ["threads", "group thread", PHONE_MAX_THREADS]
  ];
  for (const [group2, noun, max] of groups) {
    const entries = Object.entries(phone[group2] ?? {});
    if (entries.length > max) {
      problems.push(`A story can have at most ${max} ${noun}s.`);
    }
    for (const [key, entry] of entries) {
      const label = entry.name?.trim() || key;
      if (!isUsablePhoneKey(key)) {
        problems.push(
          `The ${noun} id "${key}" cannot be used. Ids are lowercase letters, numbers and hyphens, up to 32 characters.`
        );
      }
      if (!entry.name?.trim()) {
        problems.push(`Every ${noun} needs a name.`);
      }
      if (entry.avatar !== void 0 && !isUsableAvatar(entry.avatar)) {
        problems.push(
          `The picture for "${label}" must be a web address starting with https:// (or a path on this site).`
        );
      }
    }
  }
  return [...new Set(problems)];
}

// src/chompCatalog.ts
var CHOMP_MOUTHS = [
  {
    id: "duck",
    name: "Quack Attack",
    emoji: "\u{1F986}",
    description: "A giant rubber duck bill. Absolutely no table manners."
  },
  {
    id: "beaver",
    name: "Bucky Beaver",
    emoji: "\u{1F9AB}",
    description: "Two enormous teeth, twitchy whiskers. Keep the furniture away."
  },
  {
    id: "shark",
    name: "Snack Shark",
    emoji: "\u{1F988}",
    description: "A very toothy grin. Sweets are friends\u2026 and food."
  },
  {
    id: "walrus",
    name: "Sir Chomps-a-Lot",
    emoji: "\u{1F9AD}",
    description: "Magnificent tusks and a moustache with a life of its own."
  },
  {
    id: "windup",
    name: "Wind-up Gnashers",
    emoji: "\u{1F9B7}",
    description: "Runaway dentures. The key spins faster when dinner arrives."
  },
  {
    id: "monster",
    name: "Gummy Goblin",
    emoji: "\u{1F47E}",
    description: "Wonky teeth, grape jelly lips and an outrageously floppy tongue."
  },
  {
    id: "mixed",
    name: "Mixed mouths",
    emoji: "\u{1F3AD}",
    description: "Give each face a different character. A truly ridiculous group photo."
  },
  {
    id: "classic",
    name: "Original Chomp",
    emoji: "\u{1F444}",
    description: "The original big red lips."
  }
];
var MIXED = [
  "duck",
  "beaver",
  "shark",
  "walrus",
  "windup",
  "monster"
];
function resolveChompMouth(style, slot, mixStart = 0) {
  if (style !== "mixed") return style ?? "classic";
  const whole = (value) => Number.isFinite(value) ? Math.floor(value) : 0;
  const count = MIXED.length;
  const start = (whole(mixStart) % count + count) % count;
  return MIXED[(Math.max(0, whole(slot)) + start) % count];
}
export {
  ALL_SELFIE_LENSES,
  ANALYTICS_EVENTS,
  ANALYTICS_PROPERTY_KEYS,
  ANSWER_GATE_PAGE_TYPES,
  AR_SHOOTER_TARGET_CATALOG,
  AR_SHOOTER_TARGET_IDS,
  AR_SHOOTER_TARGET_INFO,
  ApplyPlaceholderError,
  CAULDRON_DECOYS_MAX,
  CAULDRON_INGREDIENT_CATALOG,
  CAULDRON_INGREDIENT_IDS,
  CAULDRON_INGREDIENT_INFO,
  CAULDRON_RECIPE_MAX,
  CAULDRON_RIDDLE_MAX_CHARS,
  CHOMP_MOUTHS,
  CIPHER_ALPHABET_SIZE,
  CIPHER_LOCK_ANSWER_PATTERN,
  CIPHER_LOCK_MAX_ANSWER_LETTERS,
  CIPHER_LOCK_MAX_SHIFT,
  CIPHER_LOCK_MIN_SHIFT,
  DEFAULT_AR_SHOOTER_TARGETS,
  DEFAULT_PHONE_THEME,
  DEFAULT_PLAYER_THEME,
  DEFAULT_SELFIE_LENSES,
  InvalidPathError,
  MAGIC_MIRROR_MAX_WORD_CHARS,
  MELODY_NOTE_COUNTS,
  MESSAGE_DELAY_MAX_SECONDS,
  NFC_TAP_FALLBACK_CODE_MAX_LENGTH,
  NFC_TAP_QUERY_PARAM,
  NFC_TAP_TOKEN_ALPHABET,
  NFC_TAP_TOKEN_LENGTH,
  NFC_TAP_TOKEN_MAX_LENGTH,
  NFC_TAP_TOKEN_MIN_LENGTH,
  NFC_TAP_TOKEN_PATTERN,
  NUMBER_LOCK_CODE_PATTERN,
  NUMBER_LOCK_MAX_DIGITS,
  NUMBER_LOCK_MIN_DIGITS,
  NUMBER_LOCK_SKIPPED_ANSWER,
  OBJECT_SCAN_DEFAULT_CONFIDENCE,
  OBJECT_SCAN_DEFAULT_HOLD_SECONDS,
  OBJECT_SCAN_MAX_CONFIDENCE,
  OBJECT_SCAN_MAX_HOLD_SECONDS,
  OBJECT_SCAN_MIN_CONFIDENCE,
  OBJECT_SCAN_TARGET_CATALOG,
  OBJECT_SCAN_TARGET_GROUPS,
  OBJECT_SCAN_TARGET_IDS,
  OBJECT_SCAN_TARGET_INFO,
  PAGE_TYPES,
  PHONE_APP_IDS,
  PHONE_KEY_PATTERN,
  PHONE_MAX_SENDERS,
  PHONE_MAX_THREADS,
  PHONE_THEMES,
  PHONE_THEME_IDS,
  PLAYER_THEMES,
  SELFIE_LENSES,
  SHOWCASE3D_MAX_SCALE,
  SHOWCASE3D_MIN_SCALE,
  SIGN_REVEAL_MAX_TEXT_CHARS,
  TOWER_ROWS_MAX,
  TOWER_ROWS_MIN,
  TOWER_SHOTS_MAX,
  TOWER_SHOTS_MIN,
  TRAIL_START_EVENTS,
  applyPlaceholders,
  arChompCamera,
  arChompFood,
  arChompMouth,
  arChompPage,
  arMarkerDisplay,
  arMarkerMount,
  arMarkerObject,
  arMarkerPage,
  arMarkerPointSchema,
  arMarkerWindowScene,
  arShooterEncounter,
  arShooterGame,
  arShooterMode,
  arShooterTargetId,
  audioPage,
  basePageType,
  basketCatchGame,
  bubbleKindFor,
  bubbleWaitsForPlayer,
  buildThreads,
  cachedTrailIsStale,
  caesarDecode,
  caesarEncode,
  cauldronBrewPage,
  cauldronIngredientId,
  cipherLockCiphertext,
  cipherLockPage,
  codeParamSchema,
  crackerRevealPage,
  createDefaultPage,
  creaturePhotoPage,
  decoderRingGame,
  decodesToAnswer,
  detectVariables,
  dueDeliveries,
  encounterAnchor,
  encounterCreature,
  encounterPlacement,
  encounterTargetKind,
  fairyAppearance,
  fairyDressStyle,
  fairyElement,
  fairyEncounterPage,
  fairyHairStyle,
  fairyWingStyle,
  feedableCharacterId,
  feedingGamePage,
  fetchTrailPoint,
  fetchTrailVersion,
  fieldManifest,
  gadgetTheme,
  generateCode,
  generateNfcToken,
  getAtPath,
  getStoriesUsingCode,
  hexColour,
  hiddenRevealStyle,
  hydratedLocationStoryPointSchema,
  hydratedNarrativeStoryPointSchema,
  hydratedStoryPointSchema,
  hydratedStorySchema,
  iframePage,
  imageSliceMatcherGame,
  isARChompPage,
  isARMarkerPage,
  isAnswerGatePage,
  isArShooterGame,
  isAudioPage,
  isBasketCatchGame,
  isCipherLockPage,
  isCrackerRevealPage,
  isDecoderRingGame,
  isFairyEncounterPage,
  isGeneratedCode,
  isHydratedLocationStoryPoint,
  isIFramePage,
  isImageSliceMatcherGamePage,
  isLocationCheckPage,
  isLuminaGame,
  isMagicMirrorPage,
  isMelodyGamePage,
  isMemoryPairsGame,
  isNfcTapPage,
  isNumberLockPage,
  isObjectScanPage,
  isObjectScanTarget,
  isPageLayout01,
  isPageLayout02,
  isPageReveal01,
  isPhoneAppId,
  isQRCheckPage,
  isQuestionPage,
  isSelfiePage,
  isShowcase3dPage,
  isSignRevealPage,
  isSignalDetectorPage,
  isSliceGame,
  isSlidingTilePuzzleGamePage,
  isSnapChaseGame,
  isSpellCastPage,
  isSpinWheelGame,
  isStackGame,
  isStarburstPage,
  isTapTheThingGamePage,
  isTargetTossGame,
  isTiltMazeGame,
  isTreasureChestPage,
  isUnlocked,
  isUsablePhoneKey,
  isValidNfcToken,
  isVideoPage,
  isVisionMatchPage,
  isWhackGame,
  locationCheckPage,
  locationPlaceholderValueSchema,
  locationPointSchema,
  luminaGame,
  luminaTarget,
  luminaTheme,
  magicMirrorGoal,
  magicMirrorPage,
  magicMirrorTheme,
  mediaRowSchema,
  melodyGamePage,
  melodyInstrument,
  memoryPairsGame,
  messageCursor,
  messageDeliveryFor,
  messageDeliverySchema,
  messagePresentation,
  mockTrail,
  nextDeliveryAt,
  nfcTapPage,
  nfcTapTagUrl,
  nfcTokenFromText,
  nfcTokenFromUrl,
  nominatimLocationSchema,
  normalizeCipherAnswer,
  normalizeMagicMirrorWord,
  normalizeNfcFallbackCode,
  normalizeNfcToken,
  normalizeShift,
  numberLockPage,
  numberLockStyle,
  objectScanPage,
  objectScanTarget,
  objectScanTargetInfo,
  page,
  pageGroupA,
  pageGroupB,
  pageLayout01,
  pageLayout02,
  pageParticles,
  pageReveal01,
  parsePath,
  phoneAppSchema,
  phoneColoursSchema,
  phoneLayout,
  phoneSenderSchema,
  phoneSettingsSchema,
  phoneThemeSpec,
  phoneThreadSchema,
  photoCharacterId,
  placeholderKindSchema,
  placeholderSchema,
  placeholderTargetSchema,
  playerTheme,
  pointApiResponseSchema,
  pointRowSchema,
  prettifyVariableKey,
  qrCheckPage,
  questionPage,
  questionPlaceholderValueSchema,
  reconcileStoryPoints,
  reducedLocationPointSchema,
  reducedStorySchema,
  reducedTrailSchema,
  replacePagesText,
  replaceSnapshotText,
  replaceStoryPointConfigText,
  replaceStorySettingsText,
  resolveChompMouth,
  resolvePhoneShell,
  resolvePhoneTheme,
  resolvePlayerTheme,
  resolveSender,
  resolveShooterTargets,
  scanSnapshotText,
  scannerTheme,
  selfieLens,
  selfiePage,
  setAtPath,
  showcase3dEnvironment,
  showcase3dModel,
  showcase3dPage,
  showcase3dParticles,
  signRevealObject,
  signRevealPage,
  signalDetectorPage,
  sliceGame,
  slidingTilePuzzleGame,
  snapChaseARPage,
  snapChaseGame,
  spellCastPage,
  spellShape,
  spinWheelGame,
  spinWheelSegment,
  spriteSpec,
  stackGame,
  starburstPage,
  storyAccessPointSchema,
  storyEditorResponseSchema,
  storyEditorSchema,
  storyPointConfigSchema,
  storyPointFullSchema,
  storyPointRowSchema,
  storyPointSchema,
  storyPointStatusSchema,
  storyRowSchema,
  storySchema,
  storySettingsSchema,
  storyShell,
  substituteVariables,
  svgPlaceholder,
  svgSpriteSheet,
  tapTheThingGame,
  targetTossGame,
  templateKey,
  templateLocationDefaultSchema,
  templateStoryPointSchema,
  templateStorySchema,
  threadKeyFor,
  tiltMazeGame,
  totalUnread,
  towerBlockKind,
  towerToppleGamePage,
  trailAttributionSchema,
  trailConfigSchema,
  trailPointSchema,
  trailRowSchema,
  trailSchema,
  trailTemplateSnapshotSchema,
  trailVersionResponseSchema,
  treasureChestPage,
  urlRedirectPointSchema,
  validateDraft,
  validateMessageDelivery,
  validatePhoneSettings,
  videoPage,
  visionMatchPage,
  wandStyle,
  whackGame,
  withFreshNfcTokens
};
